webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(abp) {'use strict';
	
	var _assign = __webpack_require__(62);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	__webpack_require__(108);
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _routers = __webpack_require__(61);
	
	var _routers2 = _interopRequireDefault(_routers);
	
	var _touch = __webpack_require__(31);
	
	var _touch2 = _interopRequireDefault(_touch);
	
	var _base = __webpack_require__(56);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _jsBridge = __webpack_require__(57);
	
	var _jsBridge2 = _interopRequireDefault(_jsBridge);
	
	__webpack_require__(58);
	
	__webpack_require__(60);
	
	var _store = __webpack_require__(59);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vueResource = __webpack_require__(138);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _fastclick = __webpack_require__(109);
	
	var _fastclick2 = _interopRequireDefault(_fastclick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//设置生产环境
	// The Vue build version to load with the `import` command
	// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
	_vue2.default.config.silent = true;
	_vue2.default.config.devtools = false;
	//设置当前服务访问域名
	window.HTTP_SERVER = abp.http_server;
	window.HTTPS = abp.https;
	window.JAVA_SERVER = abp.java_server;
	//import fastclick from 'fastclick'
	
	
	window.Zepto = window.$ = _touch2.default;
	//import Validator from 'assets/js/validator'
	
	
	__webpack_require__(107);
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.http.options.emulateJSON = true;
	_vue2.default.http.interceptors.push(function (request, next) {
	    // ...
	    // 请求发送前的处理逻辑
	    request.body = (0, _assign2.default)(request.body, {
	        appVer: '1.9.0',
	        channelId: 3000001,
	        platType: 3,
	        activitySource: sessionStorage.getItem('activitySource'),
	        activeId: sessionStorage.getItem('activeId')
	    });
	    // ...
	    next(function (response) {
	        // ...
	        // 请求发送后的处理逻辑
	        // ...
	        // 根据请求的状态，response参数会返回给successCallback或errorCallback
	        return response;
	    });
	});
	//Vue.use(Validator)
	
	
	if ('addEventListener' in document) {
	    document.addEventListener('DOMContentLoaded', function () {
	        _fastclick2.default.attach(document.body);
	    }, false);
	}
	window.Prius = _jsBridge2.default;
	var vue = new _vue2.default({
	    router: _routers2.default,
	    store: _store2.default,
	    template: '<router-view></router-view>'
	}).$mount('#app');
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _webpackZepto = __webpack_require__(141);
	
	var _webpackZepto2 = _interopRequireDefault(_webpackZepto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Swipe(tBox, args) {
	  var _this;
	  var tPoint = {
	    self: tBox,
	    count: 0,
	    speed: 300,
	    iniL: 30,
	    iniT: 30,
	    iniAngle: 30,
	    touch: false,
	    mutiTouch: false,
	    setAttr: function setAttr(name, value) {
	      tPoint[name] = value;
	    }
	  };
	
	  // init初始化
	  (function () {
	    _this = tPoint.self;
	    for (var o in args) {
	      tPoint[o] = args[o];
	    }
	    var _offset = _this.offset();
	    tPoint.bL = _offset.left;
	    tPoint.bT = _offset.top;
	    tPoint.bW = _this.width();
	    tPoint.bH = _this.height();
	    tPoint.bRb = tPoint.bL + tPoint.bW; //右边界
	    tPoint.bBb = tPoint.bT + tPoint.bH; //下边界
	    tPoint.total = _this.children().children().length;
	  })();
	
	  // 浏览器特性检测
	  tPoint.vendor = /webkit/i.test(navigator.appVersion) ? 'webkit' : /firefox/i.test(navigator.userAgent) ? 'Moz' : 'opera' in window ? 'O' : '';
	  tPoint.has3d = 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix();
	  tPoint.hasTouch = 'ontouchstart' in window;
	  tPoint.hasTransform = tPoint.vendor + 'Transform' in document.documentElement.style;
	
	  // 方向检测(左移距离，上移距离)
	  function directionDetect(l, t) {
	    if (Math.abs(t) < tPoint.iniT && Math.abs(l) > tPoint.iniL) {
	      var rStr = l < 0 ? 'left' : 'right';
	      return rStr;
	    }
	    if (Math.abs(l) < tPoint.iniT && Math.abs(t) > tPoint.iniL) {
	      var rStr = t < 0 ? 'up' : 'down';
	      return rStr;
	    }
	    return false;
	  }
	
	  // 边界检测
	  function borderDetect(x, y) {
	    return x < tPoint.bL || x > tPoint.bRb || y < tPoint.bT || y > tPoint.bBb;
	  }
	
	  // 获取夹角(通过arctant反三角函数)
	  function getAngle(n) {
	    return Math.atan(n) * 180 / Math.PI;
	  }
	
	  // 获取距离(通过两边计算第三边)
	  function getDis(xLen, yLen) {
	    return Math.sqrt(Math.pow(xLen, 2) + Math.pow(yLen, 2));
	  }
	
	  // 设置tPoint的改变数据（默认设置改变数据，如果setList存在，则遍历setList设置属性）
	  function setPointData(point, setList) {
	    if (setList) {
	      for (var o in setList) {
	        tPoint.setAttr(o, setList[o]);
	      }
	    } else {
	      var t = new Date();
	      tPoint.endX = point.pageX;
	      tPoint.endY = point.pageY;
	      tPoint.endTime = t.getTime();
	      tPoint.duration = tPoint.endTime - tPoint.startTime;
	      tPoint.mX = point.pageX - tPoint.startX; //滑动距离
	      tPoint.mY = point.pageY - tPoint.startY;
	      tPoint.direction = directionDetect(tPoint.mX, tPoint.mY);
	      tPoint.angle = getAngle(tPoint.mY / tPoint.mX);
	    }
	  }
	
	  // 多点触摸检测(只检测两点触摸)
	  function multiTouchDetect(e) {
	    tPoint.tLen = e.touches.length;
	    if (tPoint.tLen > 1) {
	      var point0 = e.touches[0],
	          point1 = e.touches[1],
	          xLen = point1.pageX - point0.pageX,
	          yLen = point1.pageY - point0.pageY,
	          angle = getAngle(yLen / xLen),
	          gDis = getDis(xLen, yLen);
	      if (!tPoint.mutiTouch) {
	        tPoint.gStartDis = gDis;
	        tPoint.gStartAngle = angle;
	      } else {
	        tPoint.gEndDis = gDis;
	        tPoint.gEndAngle = angle;
	        tPoint.scale = gDis / tPoint.gStartDis;
	        tPoint.rotation = angle - tPoint.gStartAngle;
	      }
	      tPoint.mutiTouch = true;
	    } else {
	      tPoint.mutiTouch = false;
	    };
	  }
	
	  function startFun(e) {
	    var point = e.touches[0],
	        t = new Date();
	    var setList = {
	      startX: point.pageX,
	      startY: point.pageY,
	      startTime: t.getTime(),
	      identifier: point.identifier
	    };
	    setPointData(point, setList);
	    tPoint.touch = true;
	    if (typeof tPoint.sCallback == "function") {
	      tPoint.sCallback(tPoint);
	    }
	  }
	
	  function moveFun(e) {
	    var point = e.touches[0];
	    if (borderDetect(point.pageX, point.pageY)) {
	      tPoint.touch = false;
	      return false;
	    }
	    if (tPoint.touch) {
	      setPointData(point);
	      multiTouchDetect(e); // Muti touch detect
	      if (typeof tPoint.mCallback == "function") {
	        tPoint.mCallback(tPoint);
	      }
	    }
	    if (Math.abs(tPoint.angle) < tPoint.iniAngle) {
	      e.preventDefault();
	    }
	  }
	
	  function endFun(e) {
	    tPoint.touch = false;
	    tPoint.mutiTouch = false;
	    if (typeof tPoint.eCallback == "function") {
	      tPoint.eCallback(tPoint);
	    }
	  }
	
	  // 实例化之前的回调函数
	  if (typeof tPoint.beforeCallback == "function") {
	    tPoint.beforeCallback(tPoint);
	  }
	
	  // Touch事件监听
	  _this.die("touchstart,touchmove,touchend");
	  _this.get(0).addEventListener('touchstart', startFun);
	  _this.get(0).addEventListener('touchmove', moveFun);
	  _this.get(0).addEventListener('touchend', endFun);
	
	  // 实例化之后的回调函数
	  if (typeof tPoint.afterCallback == "function") {
	    tPoint.afterCallback(tPoint);
	  }
	} //     Zepto.js
	//     (c) 2010-2014 Thomas Fuchs
	//     Zepto.js may be freely distributed under the MIT license.
	
	
	(function (a) {
	  a.fn.Swipe = function (b) {
	    return this.each(function () {
	      a(this).data("Swipe", new Swipe(a(this), b));
	    });
	  };
	})(_webpackZepto2.default);
	exports.default = _webpackZepto2.default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _passwords = __webpack_require__(121);
	
	var _passwords2 = _interopRequireDefault(_passwords);
	
	var _pages = __webpack_require__(120);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _others = __webpack_require__(119);
	
	var _others2 = _interopRequireDefault(_others);
	
	var _heads = __webpack_require__(117);
	
	var _heads2 = _interopRequireDefault(_heads);
	
	var _backTime = __webpack_require__(115);
	
	var _backTime2 = _interopRequireDefault(_backTime);
	
	var _timeLabel = __webpack_require__(123);
	
	var _timeLabel2 = _interopRequireDefault(_timeLabel);
	
	var _date = __webpack_require__(116);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _share = __webpack_require__(122);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _imgCode = __webpack_require__(118);
	
	var _imgCode2 = _interopRequireDefault(_imgCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = {
	    passwords: _passwords2.default,
	    pages: _pages2.default,
	    others: _others2.default,
	    heads: _heads2.default,
	    backs: _backTime2.default,
	    timelabel: _timeLabel2.default,
	    date: _date2.default,
	    share: _share2.default,
	    imgCode: _imgCode2.default
	};
	
	exports.default = components;

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

	var isHTTPS = location.protocol == 'https:'
	if (isHTTPS) {
	    module.exports = {
	        http_server: 'http://120.55.199.144:8101/api/',
	        https: 'https://wechat.yaduo.com/',
	        share_https: 'http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=ebf4d1&isCorp=false&pageUrl=',
	        java_server: 'https://api2.yaduo.com/'
	    }
	} else {
	    module.exports = {
	        http_server: 'http://120.55.199.144:8101/api/',
	        https: 'http://wechat.yaduo.com/',
	        share_https: 'http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=ebf4d1&isCorp=false&pageUrl=',
	        java_server: 'http://api2.yaduo.com/'
	    }
	}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: '',
	    data: function data() {
	        return {
	            val: this.msg,
	            status: false,
	            time: ''
	        };
	    },
	
	    props: ['times', 'msg', 'events', 'type', 'uuid', 'phone', 'code'],
	    methods: {
	        sendMessage: function sendMessage() {
	            event.preventDefault();
	            var _this = this;
	            var param = {
	                uuid: _this.uuid,
	                phoneNum: _this.phone,
	                code: _this.code,
	                type: _this.type
	            };
	            if (!_this.code) {
	                delete param.code;
	            }
	            if (this.status) {
	                //                    site._post('get_verify_code_by_type_wx.cgi',param,this,_this.callback,_this.error)
	            }
	        },
	        callback: function callback(data) {
	            var _this = this;
	            if (site._checkFun(_this.events)) {
	                _this.events.apply(this, [data]);
	            }
	            if (_this.status) {
	                site.getLocal('backTime', new Date().getTime());
	            }
	            _this.status = false;
	            var set = setInterval(function () {
	                _this.time -= 1;
	                _this.val = '倒计时' + _this.time + '秒';
	                if (_this.time == 0) {
	                    clearInterval(set);
	                    _this.clear();
	                }
	            }, 1000);
	        },
	        clear: function clear() {
	            this.status = true;
	            this.val = '重新发送';
	            this.time = this.getTime();
	        },
	        error: function error() {},
	        getTime: function getTime() {
	            var time = site.getLocal('backTime') ? (new Date().getTime() - site.getLocal('backTime')) / 1000 : null;
	            return time && time < this.times ? this.times - parseInt(time) : this.times;
	        }
	    },
	    components: {},
	    mounted: function mounted() {
	        this.$nextTick(function () {
	            this.time = this.getTime();
	            if (this.time != 60 && this.time > 0) {
	                this.val = '倒计时' + this.time + '秒';
	                this.callback();
	            } else {
	                this.status = true;
	            }
	        });
	    },
	    created: function created() {}
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: '',
	    data: function data() {
	        return {
	            time: parseInt(new Date().getTime() / (86400 * 1000)) * 86400 * 1000 - 31 * 86400 * 1000 - 28800000,
	            data: [],
	            cacheDate: [],
	            month: new Date().getMonth(),
	            monthName: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
	            status: false
	        };
	    },
	
	    props: ['start', 'end', 'success', 'error'],
	    methods: {
	        getDate: function getDate() {
	            var _this = this,
	                arr = [];
	            for (var n = 0; n < 12; n++) {
	                arr[n] = [];
	            }
	            for (var i = 0; i < 31; i++) {
	                var date = _this.time + i * 86400 * 1000;
	                var days = new Date(date),
	                    obj = {};
	                if (days.getMonth() == _this.month) {
	                    obj = {
	                        month: days.getMonth(),
	                        day: days.getDate(),
	                        time: date,
	                        week: days.getDay(),
	                        status: true,
	                        selected: false
	                    };
	                    arr[days.getMonth()].push(obj);
	                }
	            }
	            for (var k = 1; k < 120; k++) {
	                var _date = _this.time + (30 + k) * 86400 * 1000;
	                var _days = new Date(_date),
	                    _obj = {};
	                if (_days.getMonth() < _this.month + 4) {
	                    _obj = {
	                        month: _days.getMonth(),
	                        day: _days.getDate(),
	                        time: _date,
	                        week: _days.getDay(),
	                        selected: false
	                    };
	                    if (k < 90) {
	                        _obj.status = false;
	                    } else {
	                        _obj.status = true;
	                    }
	                    arr[_days.getMonth()].push(_obj);
	                }
	            }
	            this.data = arr;
	        },
	        setTime: function setTime(obj, ind) {
	            if ($(event.currentTarget).hasClass('gray')) {
	                return false;
	            }
	            if (!this.status) {
	                this.getStartTime(obj, ind);
	            } else {
	                if ((obj.time - this.start) / 86400000 > 30) {
	                    if (this.error) {
	                        this.error();
	                    }
	                    return false;
	                }
	                if (this.start < obj.time) {
	                    if (this.success) {
	                        this.success();
	                    }
	                    this.end = obj.time;
	                    this.status = false;
	                } else {
	                    this.getStartTime(obj, ind);
	                }
	            }
	        },
	        getStartTime: function getStartTime(obj, ind) {
	            var arr = [];
	            this.getDate();
	            for (var i = 0; i < this.data.length; i++) {
	                arr[i] = this.data[i];
	            }
	            this.start = obj.time;
	            this.end = '';
	            this.status = true;
	            arr[obj.month][ind].selected = true;
	            this.data = arr;
	        }
	    },
	    components: {},
	    mounted: function mounted() {
	        this.$nextTick(function () {
	            this.getDate();
	        });
	    },
	    created: function created() {}
	};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: '',
	    data: function data() {
	        return {
	            title: document.title,
	            rights: '',
	            lefts: ''
	        };
	    },
	
	    props: ['left', 'right', 'titles', 'events'],
	    methods: {
	        toGo: function toGo() {
	            if (this.hrefs) {
	                window.location.href = this.hrefs;
	            }
	        }
	    },
	    components: {},
	    mounted: function mounted() {
	        this.$nextTick(function () {});
	    },
	    created: function created() {}
	};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'imgCode',
	    props: {
	        show: {
	            type: Boolean,
	            default: false
	        },
	        phone: Number,
	        codeType: Number
	    },
	    data: function data() {
	        return {
	            code: '',
	            codeKey: '',
	            imgCode: '',
	            isPost: true,
	            calculationTime: 60
	        };
	    },
	
	    watch: {
	        show: function show(val) {
	            if (val == true) {
	                this.code = '';
	                this.getImg();
	            }
	        }
	    },
	    methods: {
	        getCodeKey: function getCodeKey(res) {
	            //获取图形验证码
	            var data = res.body;
	            if (data.retcode == 0) {
	                this.codeKey = data.result;
	                this.imgCode = JAVA_SERVER + 'atourlife/verifyCode/getCodeImage?codeKey=' + data.result + '&appVer=1.4.0&channelId=3000001&platType=3';
	            } else {
	                toast.showToast(data.retmsg);
	            }
	        },
	        getImg: function getImg() {
	            this.$http.post(JAVA_SERVER + 'atourlife/verifyCode/getCodeKey', {}).then(this.getCodeKey);
	        },
	        getCode: function getCode() {
	            //获取短信验证码
	            if (!this.phone) {
	                toast.showToast("请输入手机号！");
	                return false;
	            } else if (!/^1[3|4|5|7|8][0-9]{9}$/.test(this.phone)) {
	                toast.showToast("手机号格式不正确！");
	                return false;
	            } else if (!this.code) {
	                toast.showToast("请输入验证码！");
	                return false;
	            }
	            localStorage.setItem("phoneNum", this.phone);
	            this.inspectTime();
	            this.clickGetTime();
	            var param = {
	                phoneNum: this.phone,
	                code: this.code,
	                codeKey: this.codeKey,
	                type: this.codeType
	            };
	            this.$http.post(JAVA_SERVER + 'atourlife/verifyCode/getVerifyCodeByTypeForH5', param).then(this.getVerifyCodeByType);
	        },
	        getVerifyCodeByType: function getVerifyCodeByType(res) {
	            var data = res.body;
	            if (data.retcode == 0) {
	                this.$emit('showOff');
	                toast.showToast("发送成功！");
	            } else {
	                toast.showToast(data.retmsg);
	            }
	        },
	        inspectTime: function inspectTime(isAddTime) {
	            var startTime = localStorage.getItem("startTime");
	            var nowTime = new Date().getTime();
	            var differ = parseInt((nowTime - startTime) / 1000); //时间差
	            if (differ > this.calculationTime && !isAddTime) {
	                localStorage.setItem("startTime", new Date().getTime());
	            } else if (differ < this.calculationTime) {
	                this.calculationTime = this.calculationTime - differ;
	                return true;
	            }
	            return false;
	        },
	        clickGetTime: function clickGetTime() {
	            var time = this.calculationTime;
	            var code = $('.msg');
	            if (this.isPost) {
	                this.isPost = false;
	                code.addClass("msg_active");
	                var timer = setInterval(function () {
	                    time--;
	                    code.html(time + "秒");
	                    if (time == 0) {
	                        clearInterval(timer);
	                        code.html("重新获取");
	                        this.code = '';
	                        this.calculationTime = 60;
	                        localStorage.setItem("startTime", null);
	                        this.isPost = true;
	                        code.removeClass("msg_active");
	                    }
	                }, 1000);
	            }
	        }
	    },
	    mounted: function mounted() {
	        this.$nextTick(function () {
	            if (this.inspectTime(true)) {
	                this.phone = localStorage.getItem("phoneNum");
	                this.clickGetTime();
	            }
	        });
	    }
	};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: '',
	    data: function data() {
	        return {};
	    },
	
	    props: ['code', 'status', 'imgs', 'classes'],
	    methods: {
	        toCancel: function toCancel() {
	            this.$parent.$emit('cancel' + this.code);
	        }
	    },
	    components: {},
	    mounted: function mounted() {
	        this.$nextTick(function () {});
	    },
	    created: function created() {
	        var _this2 = this;
	
	        var _this = this,
	            params = [];
	        var parent = _this.$parent,
	            events = parent[_this.events],
	            code = _this.code;
	        parent.$on('cancel' + code, function (w) {
	            parent.toasts[code] = false;
	            params = events && events.cancelParam ? [events.cancelParam].concat(w) : w;
	            if (events && events.cancel && _this._checkFun(parent[events.cancel])) parent[events.cancel].apply(_this2, [params]);
	        });
	    }
	};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: '',
	    data: function data() {
	        return {
	            html: ''
	        };
	    },
	
	    props: ['code', 'classes', 'status', 'content', 'binds'],
	    methods: {
	        toCancel: function toCancel() {
	            this.binds = '';
	            this.$parent.$emit('cancel' + this.code);
	        }
	    },
	    components: {},
	    mounted: function mounted() {
	        this.$nextTick(function () {});
	    },
	    created: function created() {
	        var _this2 = this;
	
	        var _this = this,
	            params = [];
	        var parent = _this.$parent,
	            events = parent[_this.events],
	            code = _this.code;
	        parent.$on('cancel' + code, function (w) {
	            parent.toasts[code] = false;
	            params = events && events.cancelParam ? [events.cancelParam].concat(w) : w;
	            if (events && events.cancel && _this._checkFun(parent[events.cancel])) parent[events.cancel].apply(_this2, [params]);
	        });
	    }
	};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: '',
	    data: function data() {
	        return {
	            num: 6,
	            password: ''
	        };
	    },
	
	    props: ['code', 'type', 'status', 'content', 'top', 'events'],
	    methods: {
	        toCancel: function toCancel() {
	            this.$parent.$emit('cancel' + this.code);
	        },
	        submit: function submit() {
	            var _this = this;
	            if (this.password.length == 6) {
	                this.$parent.$emit('passwordPay' + this.code, [_this.password]);
	                this.password = '';
	            } else {
	                site.toast(_this.$parent, 'toasts', '请输入6位密码');
	            }
	        }
	    },
	    components: {},
	    mounted: function mounted() {
	        this.$nextTick(function () {});
	    },
	    created: function created() {
	        var _this2 = this;
	
	        var _this = this,
	            params = [];
	        var parent = _this.$parent,
	            events = parent[_this.events],
	            code = _this.code;
	        parent.$on('passwordPay' + _this.code, function () {
	            var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            params = events && events.confirmParam ? [events.confirmParam].concat(w) : w;
	            parent.toasts[code] = false;
	            if (events && events.submit && site._checkFun(parent[events.submit])) parent[events.submit].apply(_this2, [params]);
	        });
	        parent.$on('cancel' + code, function (w) {
	            parent.toasts[code] = false;
	            params = events && events.cancelParam ? [events.cancelParam].concat(w) : w;
	            if (events && events.cancel && _this._checkFun(parent[events.cancel])) parent[events.cancel].apply(_this2, [params]);
	        });
	    }
	};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: '',
	    data: function data() {
	        return {
	            status: false,
	            statuses: false
	        };
	    },
	
	    props: ['callback', 'title', 'desc', 'imgUrl', 'link', 'type', 'shareimage'],
	    methods: {
	        upVal: function upVal(val) {
	            return encodeURI(val);
	        },
	
	        toCancel: function toCancel() {
	            //              this.status = false
	            this.statuses = false;
	        },
	        getWxToken: function getWxToken(apiList, fun) {
	            var _this = this;
	            var puurl = encodeURIComponent(location.href.split('#')[0]);
	            //var url = "http://www.yaduo.com:9300/api/meb/GetCommonConfigByWechat?pageUrl=" + puurl;
	            //                var url = "http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=d92e36&isCorp=true&pageUrl=" + puurl;
	            var url = "http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=ebf4d1&isCorp=false&pageUrl=" + puurl; //isCorp是否是企业号 线上公众号
	
	            //                var url = "http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=eff45e&isCorp=false&pageUrl=" + puurl;//isCorp是否是企业号  测试公众号
	            //                let url = "http://www.yaduo.com:9300/api/meb/ActMebDayByGetWechatConfig?pageUrl=" + encodeURIComponent(location.href.split('#')[0]);
	            $.ajax({
	                url: url,
	                dataType: "json",
	                cache: true,
	                type: 'GET',
	                success: function success(data) {
	                    var cofigData = data.Data;
	                    var config = {
	                        debug: false, // 开启调试模式
	                        appId: cofigData.AppId, // 必填，企业号的唯一标识，此处填写企业号corpid
	                        timestamp: cofigData.TimeStamp, //必填，生成签名的时间戳
	                        nonceStr: cofigData.NonceStr, // 必填，生成签名的随机串
	                        signature: cofigData.Signature, // 必填，签名，见附录1
	                        jsApiList: apiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
	                        //startRecord开始录音接口，startRecord识别音频并返回识别结果接口，stopRecord停止录音接口，playVoice播放语音接口
	                    };$(document).ready(function () {
	                        wx.config(config);
	                        wx.error(function (res) {});
	                        if (fun) fun();
	                        _this.$parent.$emit(_this.callback);
	                    });
	                }
	            });
	        },
	        weixinSdkConfig: function weixinSdkConfig() {
	            var _this = this;
	            var param = {
	                title: _this.title,
	                desc: _this.desc,
	                link: _this.link ? _this.link : window.location.href,
	                imgUrl: _this.imgUrl ? _this.imgUrl : 'http://atour-wechat.qiniu.yaduo.com/WeChat/activity/share/shareImage1.jpg',
	                trigger: function trigger(res) {
	                    // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
	                },
	                success: function success(res) {},
	                cancel: function cancel(res) {},
	                fail: function fail(res) {
	                    //alert(JSON.stringify(res));
	                }
	            };
	            wx.ready(function () {
	                //监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
	                wx.onMenuShareAppMessage(param);
	                //监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
	                wx.onMenuShareTimeline(param);
	                //监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
	                wx.onMenuShareQQ(param);
	                //监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
	                wx.onMenuShareWeibo(param);
	            });
	        },
	        toShare: function toShare() {
	            if (site.isWeiXin()) {
	                this.weixinSdkConfig();
	                this.statuses = true;
	            } else {
	                this.status = true;
	            }
	        }
	    },
	    components: {},
	    mounted: function mounted() {
	        this.link = this.link ? this.link : window.location.href;
	        this.$nextTick(function () {
	            if (site.isWeiXin()) {
	                this.getWxToken(['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo'], this.weixinSdkConfig());
	            }
	            //                if (site.isWeiXin()) {
	            //                    this.weixinSdkConfig();
	            //                }
	        });
	    }
	};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: '',
	    data: function data() {
	        return {
	            hour: '88',
	            minute: '88',
	            second: '88',
	            time: 0
	        };
	    },
	
	    props: ['times'],
	    methods: {
	        getTime: function getTime() {
	            var time = (this.times - this.time * 1000) / 1000;
	            this.day = this.hour = parseInt(time / 3600);
	            this.minute = parseInt(time % 3600 / 60);
	            this.second = parseInt(time % 60);
	        }
	    },
	    components: {},
	    mounted: function mounted() {
	        this.$nextTick(function () {
	            this.getTime();
	            var _this = this;
	            var set = setInterval(function () {
	                if (_this.times / 1000 - _this.time > 0) {
	                    _this.time = _this.time + 1;
	                    _this.getTime();
	                } else {
	                    clearInterval(set);
	                }
	            }, 1000);
	        });
	    },
	    created: function created() {}
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _components = __webpack_require__(32);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'treatment',
	    data: function data() {
	        return {
	            isShow: false,
	            iShow: false, //控制活动介绍
	            isLogin: false,
	            marketFlag: false, //是否领取过
	            configType: false, //是否
	            configData: {},
	            marketId: "",
	            ActivityUserData: {},
	            codeKey: null,
	            code: null,
	            codeType: 1,
	            imgCode: "",
	            postData: {
	                marketId: this.$route.params.marketId,
	                phoneNum: "",
	                verifyCode: ''
	            }
	        };
	    },
	
	    methods: {
	        showToast: function showToast(type) {
	            this.iShow = type;
	        },
	        showOff: function showOff() {
	            this.isShow = false;
	        },
	        closeImg: function closeImg() {
	            this.isShow = false;
	        },
	        getImgCode: function getImgCode() {
	            //获取图形验证码
	            if (!this.postData.phoneNum) {
	                toast.showToast("请输入手机号！");
	                return false;
	            } else if (!/^1[3|4|5|7|8][0-9]{9}$/.test(this.postData.phoneNum)) {
	                toast.showToast("手机号格式不正确！");
	                return false;
	            } else {
	                this.isShow = true;
	            }
	        },
	        getMarketConfig: function getMarketConfig() {
	            //活动首页基础配置接口
	            var data = {
	                marketId: this.marketId
	            };
	            site._post(JAVA_SERVER + '/atourlife/marketConfig/getMarketConfig', data, this, function (result) {
	                if (result.retcode == 0) {
	                    this.$nextTick(function () {
	                        this.configData = result.result;
	                        this.configType = true;
	                    });
	                } else {
	                    toast.showToast(result.retmsg);
	                }
	            });
	        },
	        inspectType: function inspectType(data) {
	            if (!data || typeof data == "undefined" || typeof data == "string") {
	                return false;
	            }
	            return true;
	        },
	        receiveGifts: function receiveGifts() {
	            //活动首页领取接口
	            var data = {
	                "phoneNum": this.postData.phoneNum,
	                "marketId": this.marketId,
	                'verifyCode': this.postData.verifyCode
	            };
	            site._post(JAVA_SERVER + '/atourlife/login/receiveRedPacketByVerifyCode', data, this, function (result) {
	                if (result.retcode == 0 || result.retcode == 60008) {
	                    localStorage.setItem('getted', true);
	                    localStorage.setItem('marketId', this.marketId);
	                    localStorage.setItem('mobile', result.result.phoneNum);
	                    this.$router.replace({
	                        path: '/treatmentList/' + this.marketId,
	                        query: {
	                            activitySource: localStorage.getItem('activitySource'),
	                            activeId: localStorage.getItem('activeId')
	                        }
	                    });
	                } else {
	                    toast.showToast(result.retmsg);
	                }
	            });
	        }
	    },
	    components: _components2.default,
	    mounted: function mounted() {
	        this.marketId = this.$route.params.marketId;
	        this.$nextTick(function () {
	            this.getMarketConfig();
	            if (localStorage.getItem('getted') == 'true' && localStorage.getItem('marketId') == this.marketId) {
	                this.$router.push({
	                    path: '/treatmentList/' + this.marketId,
	                    query: {
	                        activitySource: localStorage.getItem('activitySource'),
	                        activeId: localStorage.getItem('activeId')
	                    }
	                });
	            }
	        });
	    }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _components = __webpack_require__(32);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'treatmentList',
	    data: function data() {
	        return {
	            isShow: false,
	            isLogin: false,
	            configType: false, //是否
	            userMarketFlag: true, //是否
	            phoneNum: true, //是否
	            phone: '',
	            link: "",
	            ActivityUserData: {},
	            couponList: {},
	            configData: {}
	        };
	    },
	
	    methods: {
	        upImg: function upImg() {
	            var imgUrl = '';
	            if (this.configData.marketValue != 1) {
	                imgUrl = this.configData.envelopeImage ? 'background: url(' + this.configData.envelopeImage + ') no-repeat;background-size: 100% 100%;' : '';
	            }
	            return imgUrl;
	        },
	        goWechat: function goWechat() {
	            window.location.href = HTTPS;
	        },
	
	        listTemp: function listTemp(list) {
	            var map = {},
	                dest = [];
	            for (var i = 0; i < list.length; i++) {
	                var ai = list[i];
	                if (!map[ai.value]) {
	                    dest.push({
	                        disTypeName: ai.disTypeName,
	                        value: ai.value,
	                        count: 1
	                    });
	                    map[ai.value] = ai;
	                } else {
	                    for (var j = 0; j < dest.length; j++) {
	                        var dj = dest[j];
	                        if (dj.value == ai.value) {
	                            ++dest[j].count;
	                            break;
	                        }
	                    }
	                }
	            }
	            return dest;
	        },
	        showToast: function showToast(type) {
	            this.isShow = type;
	            if (type) _czc.push(['_trackEvent', '列表活动-' + this.marketId, '点击查看规则', "点击查看规则", '1', 'playBtn']);
	        },
	        getCoupon: function getCoupon() {
	            //获取优惠券列表
	            var data = { phoneNum: this.phone, marketId: this.marketId };
	            if (this.phone) {
	                site._post(JAVA_SERVER + '/atourlife/coupon/getCouponsListByMarketIdNotToken', data, this, function (result) {
	                    if (result.retcode == 0) {
	                        if (this.configData.marketValue == 1) {
	                            this.couponList = result.result;
	                        } else {
	                            this.couponList = this.listTemp(result.result);
	                        }
	                    } else {
	                        toast.showToast(result.retmsg);
	                    }
	                });
	            }
	        },
	        inspectType: function inspectType(data) {
	            if (!data || typeof data == "undefined" || typeof data == "string") return false;
	            return true;
	        },
	        getMarketConfig: function getMarketConfig() {
	            //活动首页显示基础配置表接口
	            var data = { marketId: this.marketId };
	            site._post(JAVA_SERVER + '/atourlife/marketConfig/getMarketConfig', data, this, function (result) {
	                if (result.retcode == 0) {
	                    this.configData = result.result;
	                    this.configType = true;
	                    this.getCoupon();
	                } else {
	                    toast.showToast(result.retmsg);
	                }
	            });
	        },
	        upPhoneNum: function upPhoneNum(tel) {
	            if (tel) {
	                var mtel = tel.substr(0, 3) + '****' + tel.substr(7);
	                return mtel;
	            }
	        },
	        useAction: function useAction() {
	            if (Prius && Prius.isInsideApp) {
	                Prius.backpage({});
	            } else {
	                window.location.href = 'http://wechat.yaduo.com';
	            }
	        }
	    },
	    components: _components2.default,
	    mounted: function mounted() {
	        this.marketId = this.$route.params.marketId;
	        this.phone = localStorage.getItem('mobile');
	        this.link = location.origin + location.pathname + "#/home/" + this.marketId + "?utm_medium=" + this.marketId + '&activitySource=' + localStorage.getItem('activitySource') + '&activeId=' + localStorage.getItem('activeId');
	        if (!this.inspectType(this.ActivityUserData)) {
	            this.$router.push({
	                path: '/home/' + this.marketId,
	                query: {
	                    activitySource: localStorage.getItem('activitySource'),
	                    activeId: localStorage.getItem('activeId')
	                }
	            });
	            return false;
	        }
	        if (localStorage.getItem('marketId') != this.marketId) {
	            this.$router.push({
	                path: '/home/' + this.marketId,
	                query: {
	                    activitySource: localStorage.getItem('activitySource'),
	                    activeId: localStorage.getItem('activeId')
	                }
	            });
	        }
	        this.$nextTick(function () {
	            this.getMarketConfig();
	        });
	    }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	var base64 = {},
	    alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	var lookup = null;
	/**
	 * base64加密
	 * */
	base64.encode = function (s) {
	    var buffer = base64.toUtf8(s),
	        position = -1,
	        result = '',
	        len = buffer.length,
	        nan0 = void 0,
	        nan1 = void 0,
	        nan2 = void 0,
	        enc = [,,,];
	    while (++position < len) {
	        nan0 = buffer[position];
	        nan1 = buffer[++position];
	        enc[0] = nan0 >> 2;
	        enc[1] = (nan0 & 3) << 4 | nan1 >> 4;
	        if (isNaN(nan1)) enc[2] = enc[3] = 64;else {
	            nan2 = buffer[++position];
	            enc[2] = (nan1 & 15) << 2 | nan2 >> 6;
	            enc[3] = isNaN(nan2) ? 64 : nan2 & 63;
	        }
	        result += alphabet[enc[0]] + alphabet[enc[1]] + alphabet[enc[2]] + alphabet[enc[3]];
	    }
	    return result;
	};
	
	/**
	 * base64解密
	 * */
	base64.decode = function (s) {
	    s = s.replace(/\s/g, '');
	    if (s.length % 4) {
	        throw new Error('InvalidLengthError: decode failed: The string to be decoded is not the correct length for a base64 encoded string.');
	    }
	
	    if (/[^A-Za-z0-9+\/=\s]/g.test(s)) {
	        throw new Error('InvalidCharacterError: decode failed: The string contains characters invalid in a base64 encoded string.');
	    }
	
	    var buffer = base64.fromUtf8(s),
	        position = 0,
	        result = '',
	        len = buffer.length;
	
	    while (position < len) {
	        if (buffer[position] < 128) {
	            result += String.fromCharCode(buffer[position++]);
	        } else if (buffer[position] > 191 && buffer[position] < 224) {
	            result += String.fromCharCode((buffer[position++] & 31) << 6 | buffer[position++] & 63);
	        } else {
	            result += String.fromCharCode((buffer[position++] & 15) << 12 | (buffer[position++] & 63) << 6 | buffer[position++] & 63);
	        }
	    }
	    return result;
	};
	
	base64.toUtf8 = function (s) {
	    var _ref = [-1, s.length,, []],
	        position = _ref[0],
	        len = _ref[1],
	        chr = _ref[2],
	        buffer = _ref[3];
	
	    if (/^[\x00-\x7f]*$/.test(s)) {
	        while (++position < len) {
	            buffer.push(s.charCodeAt(position));
	        }
	    } else {
	        while (++position < len) {
	            chr = s.charCodeAt(position);
	            if (chr < 128) buffer.push(chr);else if (chr < 2048) buffer.push(chr >> 6 | 192, chr & 63 | 128);else buffer.push(chr >> 12 | 224, chr >> 6 & 63 | 128, chr & 63 | 128);
	        }
	    }
	    return buffer;
	};
	
	base64.fromUtf8 = function (s) {
	    var position = -1,
	        len = void 0,
	        buffer = [],
	        enc = [,,,];
	
	    if (!lookup) {
	        len = alphabet.length;
	        lookup = {};
	        while (++position < len) {
	            lookup[alphabet.charAt(position)] = position;
	        }
	        position = -1;
	    }
	
	    len = s.length;
	    while (++position < len) {
	        enc[0] = lookup[s.charAt(position)];
	        enc[1] = lookup[s.charAt(++position)];
	        buffer.push(enc[0] << 2 | enc[1] >> 4);
	        enc[2] = lookup[s.charAt(++position)];
	        if (enc[2] === 64) {
	            break;
	        }
	        buffer.push((enc[1] & 15) << 4 | enc[2] >> 2);
	        enc[3] = lookup[s.charAt(++position)];
	        if (enc[3] === 64) {
	            break;
	        }
	        buffer.push((enc[2] & 3) << 6 | enc[3]);
	    }
	    return buffer;
	};
	
	window.base64 = module.exports = base64;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Prius = function () {
	    /**
	     * callback 数据结构
	     * {
	    *    callId: "XXX",
	    *    onSuccess: "xxxx",
	    *    onFail: "xxxx",
	    *    onCancel: "xxxxx",
	    * }
	     * 保存所有的callback回调
	     */
	    var globalListener = {},
	        callbackList = {},
	        lookup = null;
	
	    /**
	     * 通用操作PATH列表
	     */
	
	    var PATH_LIST = {
	        LOCATION: "location", // 获取定位城市
	        SHARE: "share", // 内容分享
	        PAY_WEIXIN: "pay/weixin", // 微信支付订单
	        PAY_ALIPAY: "pay/alipay", // 支付宝支付订单
	        OPEN_NEW_PAGE: "open/newpage", // 打开新页面
	        APP_TOAST: "app/toast", // 显示toast
	        APP_DIALOG: "app/dialog", // 显示Dialog
	        APP_SHOW_LOADING: "app/showloading", //显示loading加载
	        APP_HIDE_LOADING: "app/hideloading", //隐藏loading加载
	        //APP_SHOW_LOADING_DIALOG: "app/showloadingdialog", //显示loading dialog
	        //APP_HIDE_LOADING_DIALOG: "app/hideloadingdialog", //隐藏loading dialog
	        MENU_ICON: "menu/icon", //添加icon menu
	        MENU_WORD: "menu/word", //添加word menu
	        MENU_DELETE_ALL: "menu/deleteall", //删除全部menu
	        USER_LOGIN: "user/login", //获取用户信息
	        //PAGE_HOME: "page/home", //打开首页
	        PAGE_LOGIN: "page/login", //打开用户登录页面
	        PAGE_END: "page/end", //page end
	        PAGE_BACK: "page/back", // 回退到上一页
	        HEAD_HIDE_BACK: "menu/hidebackmenu", // 隐藏返回按钮.
	        BACKPAGE: "open/backpage"
	
	        /**
	         * prius公共方法
	         * */
	    };var util = {
	        getVersion: function getVersion() {
	            if (this.isBoole('AtourBrowser')) {
	                var ua = window.navigator.userAgent;
	                var version = ua.replace(/([\s\S]*)AtourBrowser-(\S*)\/(\S*)\/([\S\s]*)/, "$3");
	                if (version !== '#') return version;
	            }
	            return null;
	        },
	
	        isBoole: function isBoole(s) {
	            if (window.navigator.userAgent) {
	                var ua = window.navigator.userAgent;
	                if (s && ua.indexOf(s, 0) != -1) return true;
	            }
	            return false;
	        }
	
	        /**
	         * prius对象
	         * */
	    };var prius = {
	        scheme: 'atourlife://',
	        isInsideApp: util.isBoole('AtourBrowser'), // 判断是否在APP应用内
	        isAtourLife: util.isBoole('AtourLife'), // 是否在亚朵应用内
	        isAtourControl: util.isBoole('AtourControl'), // 是否在亚朵控制端应用内
	        clientVersion: util.getVersion(), // 获得当前终端的版本号
	        isIOS: util.isBoole('iOS'),
	        isAndroid: util.isBoole('android'),
	        lastOpenTime: 0,
	
	        /**
	         * 触发全局监控事件
	         * @param eventId eventId
	         * @param data data
	         * data的数据结构为 （其中的data需要做base64加密）
	         * {
	             *  token: "xxxx"
	             *  other: "xxxx"
	             * }
	         */
	        fireGlobalEvent: function fireGlobalEvent(eventId, data) {
	            if (globalListener && eventId && globalListener[eventId]) {
	                globalListener[eventId].onGlobalEvent(data ? JSON.parse(data) : "");
	            }
	        },
	
	        /**
	         * native执行全局事件
	         * @param encodeEvent encodeEvent
	         * @param encodeData encodeData
	         */
	        nativeFireGlobalEvent: function nativeFireGlobalEvent(encodeEvent, encodeData) {
	            if (encodeEvent) {
	                var event = encodeEvent ? base64.decode(encodeEvent) : "";
	                var data = encodeData ? base64.decode(encodeData) : "";
	                this.fireGlobalEvent(event, data);
	            }
	        },
	
	        /**
	         * 添加全局监听事件
	         * @param eventId eventId
	         * @param listener listener
	         * @returns {boolean} 是否添加成功
	         * listener的数据结构
	         * {
	                 *  onGlobalEvent(data)
	                 * }
	         */
	        addGlobalEventListener: function addGlobalEventListener(eventId, listener) {
	            if (eventId && listener) {
	                if (globalListener[eventId]) {
	                    return true;
	                }
	                globalListener[eventId] = listener;
	                return true;
	            }
	            return false;
	        },
	
	        /**
	         * 删除全局监控事件
	         * @param eventId eventId
	         * @returns {boolean} 是否删除成功
	         */
	        removeGlobalEventListener: function removeGlobalEventListener(eventId) {
	            if (eventId) {
	                if (globalListener[eventId]) {
	                    delete globalListener[eventId];
	                    return true;
	                }
	            }
	            return false;
	        },
	
	        /**
	         * 执行访问native的url
	         */
	        nativeExecute: function nativeExecute(actionUrl) {
	            setTimeout(function () {
	                var iframe = document.createElement("IFRAME");
	                iframe.setAttribute("src", actionUrl);
	                document.documentElement.appendChild(iframe);
	                iframe.parentNode.removeChild(iframe);
	                iframe = null;
	            }, 0);
	        },
	
	        /**
	         * 将请求体Json数据加密后处理成scheme格式
	         * @param path path
	         * @param params params
	         */
	        executeActionUrl: function executeActionUrl(path, params) {
	            var actionUrl = this.scheme + path;
	            if (params) {
	                actionUrl += "?param=" + base64.encode("string" === typeof params ? params : (0, _stringify2.default)(params));
	            }
	            this.nativeExecute(actionUrl);
	        },
	
	        /**
	         * 添加一个交互回调
	         * @param callback callback
	         * @return {boolean} 是否添加回调成功
	         */
	        addCallback: function addCallback(callback) {
	
	            if (callback && callback.callId && callbackList) {
	
	                callbackList[callback.callId] = callback.listener;
	                console.log(callbackList);
	                return true;
	            }
	            return false;
	        },
	
	        /**
	         * 移除一个交互回调
	         * @param callback callback
	         * @return {boolean} 是否删除回调成功
	         */
	        removeClientCall: function removeClientCall(callback) {
	            if (callback && callback.callId && callbackList && callbackList[callback.callId]) {
	                delete callbackList[callback.callId];
	                return true;
	            }
	            return false;
	        },
	
	        /**
	         * 回调成功事例，json数据格式为以下
	         * {
	        *    callId: "xxxx/xxxx",
	        *    data: {
	        *    }
	        *  }
	         */
	        onCallbackDone: function onCallbackDone(origin) {
	            if (origin) {
	                var result = JSON.parse(base64.decode(origin));
	                if (result && result.callId) {
	                    var callback = callbackList[result.callId];
	                    callback.apply(this, [result]);
	                } else {
	                    console.log("CallbackDone.callId is null!");
	                }
	            }
	            console.log("Fail onCallbackDone, something wrong can't callback!");
	        },
	
	        /**
	         * 外链打开新的页面加载，并且是带返回按钮
	         * @data link 需要打开的网页链接
	         * @data title 标题
	         * @data showTitle {value: "0"-不添加actionbar， “1”-添加actionbar}
	         */
	        openNewPage: function openNewPage(request) {
	            var curTime = new Date().getTime();
	            if (curTime - this.lastOpenTime < 500) {
	                return;
	            }
	            this.lastOpenTime = curTime;
	            var data = request.data;
	            this.appEvent('OPEN_NEW_PAGE', data);
	        },
	
	        /**
	         * @listener 回调事件对象
	         * */
	        login: function login(request) {
	            request.callId = PATH_LIST.USER_LOGIN + new Date().getTime();
	            this.addCallback(request);
	            this.appEvent('USER_LOGIN');
	        },
	
	        /**
	         * 执行app事件
	         * */
	        appEventCallback: function appEventCallback(request) {
	            var data = request.data;
	            request.callId = PATH_LIST[request.event];
	            this.addCallback(request);
	            this.appEvent(request.event, data);
	        },
	
	        /**
	         * 执行app事件
	         * */
	        appEvent: function appEvent(event, data) {
	            var params = {
	                callId: PATH_LIST[event],
	                data: data ? data : {}
	            };
	            prius.executeActionUrl(PATH_LIST[event], params);
	        },
	
	        /**
	         * 执行关闭当前页
	         * */
	        backpage: function backpage(request) {
	            request.callId = PATH_LIST.BACKPAGE;
	            this.addCallback(request);
	            this.appEvent('BACKPAGE');
	        }
	    };
	
	    return prius;
	}();
	
	exports.default = Prius;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(65);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *@param url ajax 访问连接
	 *@param params 传输对象
	 *@param ctx 外层对象传入
	 *@param success 回调成功函数
	 *@param error 回调错误处理
	 *@param async 异步
	 *@param name 图片上传name字段
	 */
	var site = {
	    config: {
	        reload: true,
	        loadMore: true,
	        error: true
	    },
	    //当前访问服务器域名
	    javaHttp: 'http://dev-api.yaduo.com/atourlife/',
	    httpSever: 'http://dev-api.yaduo.com/atourlifeapp/',
	    newHttpSever: 'http://test-api.at-our.cn/atourlife/',
	    //  imgUrl: "http://omwalulqk.bkt.clouddn.com/", //测试
	    //    javaHttp: 'http://api.yaduo.com/atourlife/',
	    //    httpSever: 'http://apps.yaduo.com/atourlifeapp/',
	    //    newHttpSever: 'http://apps.yaduo.com/atourlife/',
	    //密钥
	    aesKey: "uA1Nl4u/+4G4LBuT",
	    ivStr: "ZH9NC3Y5K9D0M7QL",
	    // imgUrl:"http://omwalulqk.bkt.clouddn.com/",//正式图片路径地址
	    imgUrl: 'http://om89vvwsz.bkt.clouddn.com/',
	    pageSize: 10,
	    _get: function _get() {
	        var arg = arguments;
	        this.http('GET', arg, true);
	    },
	    _post: function _post() {
	        var arg = arguments;
	        this.http('POST', arg, true);
	    },
	    _put: function _put() {
	        var arg = arguments;
	        this.http('PUT', arg, true);
	    },
	    _delete: function _delete() {
	        var arg = arguments;
	        this.http('DELETE', arg, true);
	    },
	    _upload: function _upload() {
	        var oData = new FormData(document.forms.namedItem(arg[1]));
	        var arg = arguments;
	        arg[1] = oData;
	        this.http('POST', arg, false);
	    },
	    http: function http(type, arg, processData) {
	        var _http = "",
	            path = "",
	            arr = [];
	        if (arg[0].indexOf('http') != 0) {
	            _http = this.httpSever;
	            path = arg[0];
	        } else {
	            var arr = arg[0].split('//');
	            _http = arr[0] + '//' + arr[1] + '/';
	            path = arr[2];
	        }
	        var param = {
	            url: _http + path,
	            params: arg[1],
	            ctx: arg[2],
	            success: arg[3],
	            error: arg[4],
	            type: arg[5],
	            async: arg[6]
	        };
	        if (param.params.appVer == undefined) {
	            param.params = this.requestJson(param.params);
	        }
	        if (param.type) {
	            var service_name = path.match(/(\w+)\.cgi$/i);
	            if (service_name && !service_name[1]) {
	                console.log('加密 key 错误。');
	                return false;
	            }
	            param.params = this._encode(service_name[1], param.params);
	        }
	        if (param.params.appVer == undefined) {
	            param.params = this.requestJson(param.params);
	        }
	        param.processData = processData;
	        this._http(type, param);
	    },
	    _http: function _http(type, obj) {
	        var resObj = this.setArguments(type, obj);
	        var _this = this;
	        $.ajax({
	            type: type,
	            url: resObj.url,
	            data: resObj.params,
	            timeout: 60000,
	            dataType: 'json',
	            async: resObj.async,
	            processData: resObj.processData,
	            beforeSend: function beforeSend(xhr, settings) {
	                if (_this.config.reload) {
	                    $('#auour_loading').show();
	                }
	                //xhr.setRequestHeader("Authorization", "Bearer " + tokenInfo.access_token);
	            },
	            success: function success(data) {
	                if (_this.config.reload) {
	                    setTimeout(function () {
	                        $("#auour_loading").hide();
	                    }, 500);
	                }
	                if (resObj.success && Object.prototype.toString.call(resObj.success) === '[object Function]') resObj.success.apply(resObj.ctx, [data]);
	                // if(data.retcode == 0) {
	                // 	resObj.success.apply(resObj.ctx, [data]);
	                // } else {
	                // 	if(_this.config.error) {
	                // 		toast.showToast(data.retmsg);
	                // 	}
	                // }
	            },
	            error: function error(xhr, type) {
	                if (_this.config.reload) {
	                    setTimeout(function () {
	                        $("#auour_loading").hide();
	                    }, 500);
	                }
	                _this._error(xhr, type);
	                if (resObj.error && Object.prototype.toString.call(resObj.error) === '[object Function]') resObj.error.apply(resObj.ctx, [xhr, type]);
	            }
	        });
	    },
	    /**
	     * 七牛上传
	     * 例子site.qiNiuUpload('i_file','/QN/admin',callback);
	     function callback (res){
	     }
	     * html代码 <label for="i_file">
	     <span>sb</span>
	     </label>
	     * 插件'/test':[paglins.plupload,paglins.qiNiu],
	     * */
	    qiNiuUpload: function qiNiuUpload(id, path, callback) {
	        var _this = this;
	        _this.getQiNiuToken();
	        var token = _this.getLocal('qiNiuToken');
	        $("[name='token']").val(token);
	        var html = '<form method="post" name="' + id + '" class="hide" enctype="multipart/form-data">' + ' <input name="key" type="hidden" value=""> ' + '<input name="token" type="hidden" value=""> ' + '<input id="' + id + '" name="file" type="file" accept="image/jpeg" capture="camera"/> ' + '</form>';
	        if ($("qiNiuUpload").length == 0) {
	            $('body').append(html);
	        }
	        $("#" + id).change(function () {
	            var name = $(event.currentTarget).val().split('\\').pop();
	            var hash = parseInt(Math.random() * 100000000).toString();
	            $("[name='key']").val(path + '/' + hash + name);
	            $("[name='token']").val(token);
	            var _this = this;
	            setTimeout(function () {
	                var datas = new FormData(document.forms.namedItem(id));
	                $.ajax({
	                    type: 'POST',
	                    url: 'http://upload.qiniu.com/',
	                    data: datas,
	                    processData: false,
	                    contentType: false,
	                    success: function success(data) {
	                        var map = data.key + '?var=' + data.hash;
	
	                        callback.apply(_this, [{ url: map, code: 1 }]);
	                    },
	                    error: function error(xhr, type) {
	                        callback.apply(_this, [{ url: '', code: 0 }]);
	                    }
	                });
	            }, 200);
	        });
	    },
	
	    /**
	     * 七牛上传
	     * */
	    getQiNiuToken: function getQiNiuToken() {
	        var _this = this;
	        var time = new Date().getTime();
	        if (_this.getLocal('qiNiuTime') < time) {
	            _this._post(_this.javaHttp + '/image/token', {}, this, function (data) {
	                _this.getLocal({
	                    qiNiuToken: data.result.token,
	                    qiNiuTime: time + data.result.expires
	                });
	            });
	        }
	    },
	
	    /**
	     * 设置默认参数
	     * @data 原参数对象
	     * */
	    requestJson: function requestJson(data) {
	        var dataCom = {
	            appVer: '1.9.0',
	            channelId: 3000001,
	            platType: 3,
	            activitySource: localStorage.getItem('activitySource'),
	            activeId: localStorage.getItem('activeId')
	        };
	        var cookString = this.getLocal('cookString');
	        if (cookString) {
	            dataCom.cookString = cookString;
	        }
	        var request = $.extend({}, dataCom, data);
	        return request;
	    },
	    /**
	     * 获取localStorage
	     * */
	    getLocal: function getLocal() {
	        var arg = arguments;
	        var _this = this;
	        var platTypeQ = this.QueryString('platType');
	        platTypeQ = platTypeQ ? platTypeQ : _this.getCookie("platType");
	
	        if (localStorage && !platTypeQ) {
	
	            if (typeof arg[0] == 'string' && !arg[1]) {
	                var _res = localStorage.getItem(arg[0]) ? _this.deEight(localStorage.getItem(arg[0])) : localStorage.getItem(arg[0]);
	                return typeof _res == 'string' ? _res.replace(/"/g, '') : _res;
	            } else if (arg[1] !== undefined) {
	                localStorage.setItem(arg[0], _this.enEight(arg[1]));
	            }
	            if (Object.prototype.toString.call(arg[0]) == '[object Object]' && !arg[1]) {
	                for (var i in arg[0]) {
	                    localStorage.setItem(i, _this.enEight(arg[0][i]));
	                }
	            } else if (Object.prototype.toString.call(arg[0]) == '[object Array]' && !arg[1]) {
	                var arr = [];
	                for (var j = 0; j < arg[0]; j++) {
	                    arr.push(_this.deEight(localStorage.getItem(j)));
	                }
	            }
	        } else {
	            if (arg[0] && typeof arg[0] == 'string' && arg[1] == undefined) {
	                return _this.getCookie(arg[0]);
	            } else if (arg[1]) {
	                _this.setCookie(arg[0], arg[1]);
	            }
	            if (Object.prototype.toString.call(arg[0]) == '[object Object]' && !arg[1]) {
	                for (var i in arg[0]) {
	                    _this.setCookie(i, arg[0][i]);
	                }
	            } else if (Object.prototype.toString.call(arg[0]) == '[object Array]' && !arg[1]) {
	                var arr = [];
	                for (var j = 0; j < arg[0]; j++) {
	                    arr.push(_this.getCookie(j));
	                }
	            }
	        }
	    },
	
	    /**
	     * 获取sessionStorage
	     * */
	    getSession: function getSession() {
	        var arg = arguments;
	        var _this = this;
	        var platTypeQ = this.QueryString('platType');
	        platTypeQ = platTypeQ ? platTypeQ : _this.getCookie("platType");
	        if (localStorage && !platTypeQ) {
	            if (typeof arg[0] == 'string' && arg[1] == undefined) {
	                return _this.deEight(sessionStorage.getItem(arg[0]));
	            } else if (arg[1] != undefined) {
	                sessionStorage.setItem(arg[0], _this.enEight(arg[1]));
	            }
	            if (Object.prototype.toString.call(arg[0]) == '[object Object]' && !arg[1]) {
	                for (var i in arg[0]) {
	                    sessionStorage.setItem(i, _this.enEight(arg[0][i]));
	                }
	            } else if (Object.prototype.toString.call(arg[0]) == '[object Array]' && !arg[1]) {
	                var arr = [];
	                for (var j = 0; j < arg[0]; j++) {
	                    arr.push(_this.deEight(sessionStorage.getItem(j)));
	                }
	            }
	        } else {
	            if (typeof arg[0] == 'string' && arg[1] == undefined) {
	                return _this.getCookie(arg[0]);
	            } else if (arg[1] != undefined) {
	                _this.setCookie(arg[0], arg[1]);
	            }
	            if (Object.prototype.toString.call(arg[0]) == '[object Object]' && !arg[1]) {
	                for (var i in arg[0]) {
	                    _this.setCookie(i, arg[0][i]);
	                }
	            } else if (Object.prototype.toString.call(arg[0]) == '[object Array]' && !arg[1]) {
	                var arr = [];
	                for (var j = 0; j < arg[0]; j++) {
	                    arr.push(_this.getCookie(j));
	                }
	            }
	        }
	    },
	    getCookie: function getCookie(name) {
	        //匹配字段
	        var arr,
	            reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)"),
	            res,
	            r;
	        if (arr = document.cookie.match(reg)) {
	            r = decodeURIComponent(arr[2]);
	            if (this.isJSON(r)) {
	                res = JSON.parse(decodeURIComponent(arr[2]));
	            }
	        } else {}
	        return res ? res : r;
	    },
	    isJSON: function isJSON(str) {
	        if (typeof str == 'string') {
	            try {
	                JSON.parse(str);
	                return true;
	            } catch (e) {
	                console.log(e);
	                return false;
	            }
	        }
	    },
	    setCookie: function setCookie(name, value) {
	        //定义一天
	        var days = 1;
	        var exp = new Date();
	        //定义的失效时间，
	        exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
	        if (Object.prototype.toString.call(value) == '[object Object]') {
	            value = (0, _stringify2.default)(value);
	        }
	        //写入Cookie  ，toGMTstring将时间转换成字符串。
	        document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString();
	    },
	    /**
	     * 8进制解密
	     * @txt 8进制对象
	     * */
	    deEight: function deEight(txt) {
	        if (typeof txt == 'number' || typeof txt == 'string' && txt.indexOf('\\') < 0) {
	            return txt;
	        }
	        if (txt) {
	            var monyer = new Array();
	            var i;
	            var s = txt.split("\\");
	            for (i = 1; i < s.length; i++) {
	                monyer += String.fromCharCode(parseInt(s[i], 8));
	            }
	            if (monyer) return JSON.parse(monyer);
	        }
	        return "";
	    },
	
	    /**
	     * 8进制解密
	     * @txt 字符串对象
	     * */
	    enEight: function enEight(txt) {
	        if (txt) {
	            txt = (0, _stringify2.default)(txt);
	            var monyer = new Array();
	            var i;
	            for (i = 0; i < txt.length; i++) {
	                monyer += "\\" + txt.charCodeAt(i).toString(8);
	            }return monyer;
	        }
	        return "";
	    },
	
	    /**
	     * 判断传输类型
	     * */
	    setArguments: function setArguments(type, obj) {
	        var resObj = obj;
	        resObj.async = resObj.async ? true : false;
	        return resObj;
	    },
	
	    /**
	     * ajax错误处理
	     * */
	    _error: function _error(xhr, type) {
	        var behavior = JSON.parse(xhr.responseText).behavior;
	        if (behavior.type == "TOAST") {
	            this.showToast(behavior.content);
	        } else {
	            this.showToastKeep(behavior.content);
	        }
	    },
	
	    /**
	     * 判断是否是函数方法
	     * */
	    _checkFun: function _checkFun(fun) {
	        return fun && Object.prototype.toString.call(fun) === '[object Function]';
	    },
	
	    /**
	     * 传输数据加密
	     * */
	    _encode: function _encode(keyStr, params) {
	        var _this = this,
	            JSONObject,
	            //加密前json字符串
	        key,
	            //密钥
	        EncryptStr,
	            //aes加密
	        md5Str,
	            //md5加密
	        data; //加密后数据
	        JSONObject = typeof params == 'string' ? _this._parse_parameter(params) : (0, _stringify2.default)(params);
	        key = (keyStr + _this.aesKey).substring(0, 16);
	        EncryptStr = aesEncrypt(JSONObject, key, _this.ivStr);
	        md5Str = CryptoJS.MD5(EncryptStr).toString().toUpperCase();
	        data = { encodeString: EncryptStr, md5: md5Str, platType: 3 };
	        return data;
	    },
	
	    /**
	     * 将parameter字符串转化为json格式字符串
	     * */
	    _parse_parameter: function _parse_parameter(str) {
	        return "{'" + str.replace(/=/g, "':'").replace(/&/g, "','") + "'}";
	    },
	
	    /**
	     * 将json数据对象整合为字段
	     * */
	    combiningStr: function combiningStr(data) {
	        var h = "";
	        if (data && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) == 'object') for (var i in data) {
	            h += i;
	        }
	        return h;
	    },
	
	    /**
	     * 截取url参数search
	     * @key 参数键值
	     * */
	    QueryString: function QueryString(key) {
	        var uri = decodeURIComponent(window.location.search);
	        var re = new RegExp("[\&\?]" + key + "\=([^\&]*)", "ig");
	        return uri.match(re) ? uri.match(re)[0].substr(key.length + 2) : null;
	    },
	
	    /**
	     * 截取url参数hash
	     * @key 参数键值
	     * */
	    Queryhash: function Queryhash(key) {
	        var uri = decodeURIComponent(window.location.hash);
	        var re = new RegExp("[\&\?]" + key + "\=([^\&]*)", "ig");
	        return uri.match(re) ? uri.match(re)[0].substr(key.length + 2) : null;
	    },
	
	    /**
	     * template模板化
	     * @id template的id
	     * */
	    setTpl: function setTpl(id) {
	        var tpl = _.template($("#" + id).html());
	        $("#" + id).remove();
	        return tpl;
	    },
	
	    /**
	     * 判断是否登录
	     * */
	    isLogin: function isLogin() {
	        var uid = this.getLocal('uid') && this.getLocal('uid') != undefined && this.getLocal('uid') != 'undefined' && this.getLocal('uid') != null && this.getLocal('uid') != 'null' ? this.getLocal('uid') : '';
	        var userData = site.getLocal('userData');
	        if (!uid || !userData) {
	            site.getSession("goUrl", location.href);
	            return false;
	        } else {
	            return true;
	        }
	    },
	
	    /**
	     * 会员权限设置跳转
	     * */
	    loginAndGo: function loginAndGo(url) {
	        if (this.isLogin()) {
	            window.location.href = url;
	        } else {
	            window.location.href = 'login.html';
	        }
	    },
	
	    /**
	     * 设置路径缓存
	     * */
	    setHistoryUrl: function setHistoryUrl() {
	        var url = window.location.href;
	        var historyUrl = this.getLocal('current');
	        if (url != historyUrl) {
	            this.getLocal('referer', historyUrl);
	            this.getLocal('current', url);
	        }
	    },
	
	    /**
	     * 输入捆绑删除
	     * @data form表单输入框的data-input
	     * */
	    inputBindDelete: function inputBindDelete(data) {
	        var input = $("[data-input=" + data + "]");
	        var _this = this;
	        input.off("focus", _this.toggleInputDelete).on("focus", { status: true, ctx: _this }, _this.toggleInputDelete);
	    },
	
	    /**
	     * 密码捆绑查看
	     * @data form表单输入框的data-input
	     * */
	    passWordBindSee: function passWordBindSee(data) {
	        var passWord = $("[data-input=" + data + "]");
	        var html = '<i class="icon-see"></i>';
	        var icon = '<span class="icon-box"></span>';
	        if (passWord.siblings('.icon-box').length == 0) {
	            passWord.after(icon);
	        }
	        passWord.siblings('.icon-box').prepend(html);
	        var passWordBtn = $(".icon-see");
	        var _this = this;
	        passWordBtn.off("click", _this.passWordSee).on("click", _this.passWordSee);
	    },
	
	    /**
	     * 密码查看
	     * */
	    passWordSee: function passWordSee(e) {
	        var input = $(e.currentTarget).prev();
	        $(e.currentTarget).toggleClass("all");
	        var type = input.attr('type') == 'password' ? 'text' : 'password';
	        input.attr('type', type);
	    },
	
	    /**
	     * input删除按钮显示
	     * */
	    toggleInputDelete: function toggleInputDelete(e) {
	        var html = '<i class="icon-del"></i>';
	        var icon = '<span class="icon-box"></span>';
	        if ($(e.currentTarget).siblings('.icon-box').length == 0) {
	            $(e.currentTarget).after(icon);
	        }
	        if (e.data.status) {
	            if ($(e.currentTarget).siblings('.icon-box').children().eq(0).attr('class') != 'icon-del') {
	                $(e.currentTarget).siblings('.icon-box').prepend(html);
	                $(".icon-del").on('click', e.data.ctx.inputDelete);
	            }
	        }
	    },
	
	    /**
	     * 表单校验
	     * @data form表单输入框的data-require
	     * @callback 报错回调执行
	     * @param 报错回调执行参数
	     * 例子:<input type="password" data-require="true" data-pattern="/^.{4,8}$/" data-name="密码" data-alert="重复" data-input="password" style="margin-bottom: 100px">
	     * <input type="text" data-input="del" style="margin-bottom: 100px">
	     * site.passWordBindSee("password");
	     * site.inputBindDelete("del");
	     * site.inputClear();
	     *
	     * */
	    formCheck: function formCheck(callback, param) {
	        var input = $("[data-require]");
	        var _this = this;
	        for (var i = 0; i < input.length; i++) {
	            var obj = input.eq(i);
	            var status = _this.inputCheck(obj, callback, param);
	            if (!status) return false;
	        }
	        return true;
	    },
	
	    /**
	     * 单个input验证
	     * @obj 当前input节点
	     * @callback 当前input节点,回调参数param(传入的参数),obj(报错指向的节点),例:function(param,obj){}
	     * @param 报错回调执行参数
	     * */
	    inputCheck: function inputCheck(obj, callback, param) {
	        var val = obj.val();
	        var name = obj.data('name') ? obj.data('name') : obj.prev('label').text();
	        if (val.replace(/\s*/g, "") == '' && obj.data('require') == true) {
	            this.error(name + '不能为空', callback, param, obj);
	            return false;
	        }
	        var pattern = obj.data("pattern");
	        var msg = obj.data("alert") ? obj.data("alert") : name + '格式不正确';
	        if (pattern && val) {
	            var reg = eval(pattern);
	            if (!reg.test(val)) {
	                this.error(msg, callback, param, obj);
	                return false;
	            }
	        }
	        return true;
	    },
	
	    /**
	     * 表单判重复
	     * @data form表单输入框的data-repeat
	     * @callback 报错回调执行,回调参数param(传入的参数),obj(报错指向的节点),例:function(param,obj){}
	     * @param 报错回调执行参数
	     * */
	    checkRepeat: function checkRepeat(data, callback, param) {
	        var input = $("[data-repeat=" + data + "]");
	        var _this = this;
	        if (input.eq(0).val() != input.eq(1).val()) {
	            _this.error('两次密码不一致', callback, param, input.eq(1));
	            return false;
	        }
	    },
	
	    /**
	     * 回调报错
	     * @msg 默认报错字段
	     * @callback 报错回调执行,回调参数param(传入的参数),obj(报错指向的节点),例:function(param,obj){}
	     * @param 报错回调执行参数
	     * @obj 报错指向的input节点
	     * */
	    error: function error(msg, callback, param, obj) {
	        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
	            callback.apply(this, [param, obj]);
	        } else {
	            toast.showToast(msg);
	        }
	    },
	
	    /**
	     * 本节点的上一个input节点内容删除
	     * */
	    inputDelete: function inputDelete(e) {
	        $(e.currentTarget).prev().val("");
	    },
	
	    /**
	     * input清除按钮
	     * @callback 报错回调执行,回调参数param(传入的参数),obj(报错指向的节点),例:function(param,obj){}
	     * @param 报错回调执行参数
	     * */
	    inputClear: function inputClear(callback, param) {
	        $("input").on('focus', function (e) {
	            if ($(e.currentTarget).next().attr('class') != 'icon-del') {
	                $(".icon-del").remove();
	            }
	            if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
	                callback.apply(this, [param, $(e.currentTarget)]);
	            }
	        });
	        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
	            callback.apply(this, [param]);
	        }
	    },
	    /**
	     * 获取时间年月日
	     * @time 时间戳或者标准时间格式'2017/1/1'
	     * */
	    getTime: function getTime(time) {
	        var t = typeof time == 'number' ? time : time.replace(/-/g, '/');
	        var _time = "",
	            obj_time = {};
	        if (typeof time == 'number') {
	            _time = new Date(parseInt(t));
	        } else {
	            _time = new Date(t);
	        }
	        obj_time.year = _time.getFullYear();
	        obj_time.month = _time.getMonth() + 1;
	        obj_time.day = _time.getDate();
	        obj_time.hour = _time.getHours();
	        obj_time.time = _time.getTime();
	        return obj_time;
	    },
	    /**
	     * 获取预定详细时间年月日
	     * */
	    getTimeDetail: function getTimeDetail(start, end) {
	        var startTime = start ? start : site.getSession("startMonth");
	        var endTime = end ? end : site.getSession("endMonth");
	        var day = (new Date(endTime).getTime() - new Date(startTime).getTime()) / 86400000;
	        var days = day ? day : site.getSession("allday");
	        var time = {
	            startTime: site.getTime(startTime ? startTime : new Date().getTime()),
	            endTime: site.getTime(endTime ? endTime : new Date().getTime() + 86400000),
	            allDay: days ? days : 1
	        };
	        return time;
	    },
	    /**
	     * 时间去0,加0
	     * */
	    exchangeTime: function exchangeTime(time, b) {
	        var t = time.split('-');
	        if (b) {
	            return parseInt(t[0]) + '-' + parseInt(t[1]) + '-' + parseInt(t[2]);
	        } else {
	            return t[0] + '-' + (t[1] < 10 ? '0' + parseInt(t[1]) : t[1]) + '-' + (t[2] < 10 ? '0' + parseInt(t[2]) : t[2]);
	        }
	    },
	
	    /**
	     * 时间戳转时间
	     * */
	    parseTime: function parseTime(num) {
	        var _time = new Date(parseInt(time));
	        return _time.getFullYear() + '-' + (_time.getMonth() + 1) + '-' + _time.getDate();
	    },
	
	    /**
	     * 执行跳转
	     * */
	    goUrl: function goUrl(url) {
	        location.href = url;
	    },
	
	    /**
	     * 字符串转json
	     * */
	    strToObj: function strToObj(str) {
	        var obj = {};
	        str = str.serialize();
	        str = str.replace(/&/g, "','");
	        str = str.replace(/=/g, "':'");
	        if (str) {
	            str = decodeURIComponent("({'" + str + "'})");
	            obj = eval(str);
	        }
	        return obj;
	    },
	
	    /**
	     * 阿拉伯数字转换成中文数字
	     * */
	    translateNumber: function translateNumber(numberText) {
	        numberText = numberText.toString();
	        var CHINESE_NEGATIVE = "负";
	        var CHINESE_ZERO = "零";
	        var CHINESE_DIGITS = ["", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
	        var CHINESE_GROUP_UNITS = ["", "十", "百", "千", "万", "亿", "兆", "京", "垓", "杼", "穰", "溝", "澗", "正", "載", "極"];
	        var arr = [],
	            len1 = 0,
	            len2 = 0,
	            text1 = "",
	            text2 = "";
	        var type = numberText.indexOf('.') > 0 ? true : false;
	        var result = "";
	        if (type) {
	            arr = numberText.split('.');
	            text1 = arr[0];
	            text2 = arr[1];
	            len1 = text1.length;
	            len2 = text2.length;
	        } else {
	            len1 = numberText.length;
	            text1 = numberText;
	        }
	        if (numberText.substr(0, 1) == '-') {
	            result += CHINESE_NEGATIVE;
	            len1 -= 1;
	            text1 = text1.replace('-', "");
	        }
	        for (var i = 0; i < len1; i++) {
	            result += CHINESE_DIGITS[text1[i]] + CHINESE_GROUP_UNITS[len1 - i - 1];
	        }
	        if (type) {
	            if (result == "") {
	                result += CHINESE_ZERO;
	            }
	            result += CHINESE_ZERO;
	        }
	        for (var j = 0; j < len2; j++) {
	            result += text2[j] == 0 ? CHINESE_ZERO : CHINESE_DIGITS[text2[j]];
	        }
	        return result;
	    },
	
	    myScroll: function myScroll() {},
	    /**
	     * 加载更多
	     * */
	    loadMore: function loadMore(callback, param, b, s) {
	        var win = b ? $(b) : $(window);
	        win.scroll(function () {
	            var box = s ? $(s) : $('body');
	            if (win.scrollTop() > box.height() - 40 - win.height()) {
	                $('.pullUpLabel').html('加载中...');
	                callback.apply(this, [param]);
	                setTimeout(function () {
	                    $('.pullUpLabel').html('查看更多');
	                }, 1000);
	            }
	        });
	    },
	
	    /**
	     * 判断数组内存在元素
	     * */
	    contains: function contains(arr, obj) {
	        var i = arr ? arr.length : null;
	        if (i) {
	            while (i--) {
	                if (arr[i] === obj) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    },
	
	    /**
	     * 获取所有的session并且拼接
	     * */
	    parsePrameter: function parsePrameter() {
	        var res = "";
	        for (var i in sessionStorage) {
	            res += '&' + i + '=' + sessionStorage[i];
	        }
	        res = res.replace('&', '/?');
	        location.hash = res;
	    },
	
	    /**
	     * 获取所有的search并且存储
	     * */
	    parseSession: function parseSession() {
	        var res,
	            arr = [];
	        if (location.hash.indexOf('#/?') > -1) {
	            res = location.hash.split('#/?')[1];
	            arr = res.split('&');
	        }
	        var _this = this;
	        for (var i = 0; i < arr.length; i++) {
	            var k = arr[i].indexOf('=') > 0 ? arr[i].split('=') : null;
	            if (k) {
	                sessionStorage.setItem(k[0], k[1]);
	            }
	        }
	    },
	
	    /**
	     * 渲染头部
	     * @data {title:'',left:'',right:'',mid:'',}
	     * @type 模板
	     * */
	    renderHeader: function renderHeader(data, type) {
	        var platTypeQ = this.QueryString('platType');
	        if (platTypeQ) {
	            this.getSession("platType", platTypeQ);
	            $("body").css("margin-top", "-48px");
	            return false;
	        } else if (this.getCookie('platType')) {
	            $("body").css("margin-top", "-48px");
	            return false;
	        }
	        var tpl = [];
	        var home = "'home.html'";
	        var center = "'loginUserCenter.html'";
	        tpl[0] = '<header class="header-box clearfix white-bg" data-header = "1"> ' + '<p class="header-left-box" onclick="site.goUrl(' + home + ')"> ' + '<img src="app/image/history/home_d@2x.png"/><span>首页</span> </p>' + ' <p class="header-right-box" onclick="site.goUrl(' + center + ')">' + ' <img src="app/image/history/me_d@2x.png"/><span>我的</span> </p> ' + '<p class="text-center header-title"></p> </header>';
	
	        tpl[1] = '<div class="header-com" data-header="1">' + '<p class="header-return-img"></p> ' + '<div class="header-mid-text"><span><%=data.title%></span></div> ' + '</div>';
	
	        var i = $("#i_header").data('map') ? $("#i_header").data('map') : 0;
	        var map = [{
	            hotel: "http://h5.at-our.yaduo.com/weixin/image/personalCenter/home_d.png",
	            center: "http://h5.at-our.yaduo.com/weixin/image/personalCenter/me_s.png"
	        }, {
	            hotel: "http://h5.at-our.yaduo.com/weixin/image/personalCenter/home_s.png",
	            center: "http://h5.at-our.yaduo.com/weixin/image/personalCenter/me_d.png"
	        }];
	        tpl[2] = '<header class="header-pcHeader"> ' + '<div class="header-content"><p class="header-pcImg"></p> ' + '<div class="header-mid-text"><span>' + (data.title ? data.title : '') + '</span></div> ' + (data.icon ? data.icon : '') + '</div> <div class="header-pcDropDown"><div class="box"> ' + '<a href="home.html" class="header-pcDropBox hotel cell-bl-1"> ' + '<img src="' + map[i].hotel + '" /> ' + '<p class="fs14">首页</p> ' + '</a> ' + '<a href="loginUserCenter.html" class="header-pcDropBox center cell-bl-1"> ' + '<img src="' + map[i].center + '" /> ' + '<p>我的</p> ' + '</a> ' + '</div>' + '</header>';
	
	        var headerTplFun = _.template(tpl[type]);
	        var header = $("#i_header");
	        header.html(headerTplFun({ data: data }));
	        $("title").text($(".header-mid-text").text());
	        $(".header-return-img").off().on('click', function () {
	            if (data.left && Object.prototype.toString.call(data.left) === '[object Function]') {
	                data.left.apply();
	            } else {
	                history.back();
	            }
	        });
	        $(".header-mid-text").off().on('click', function () {
	            if (data.mid && Object.prototype.toString.call(data.mid) === '[object Function]') {
	                data.mid.apply();
	            }
	        });
	        $(".header-pcImg").off().on('click', function () {
	            $(event.currentTarget).toggleClass('on');
	            $(".header-pcDropDown").toggleClass('all');
	        });
	    }, /**
	       * 是否在微信
	       * */
	    isWeiXin: function isWeiXin() {
	        var ua = window.navigator.userAgent.toLowerCase();
	        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
	            return true;
	        } else {
	            return false;
	        }
	    },
	    /**
	     * 微信分享
	     * imgUrl: data.imgUrl, // 分享图标
	     * title: data.title, // 分享标题
	     * dec: data.desc, // 分享描述
	     * link: data.link, // 分享链接
	     * cancel: data.cancel, // 分享取消
	     * {imgUrl:imgUrl,title:title,dec:desc,link:link,cancel:cancel}
	     **/
	    weixinSdkConfig: function weixinSdkConfig(datas) {
	        var title = "亚朵生活"; // 分享标题
	        if (datas.title) title = datas.title;
	        var dec = document.title;
	        if (datas.dec) dec = datas.dec;
	        var share_url = window.location.href; // 分享链接
	        if (datas.link) share_url = datas.link;
	        var imgUrl = "http://atour-wechat.qiniu.yaduo.com/logo.png"; // 分享图标
	        if (datas.imgUrl) imgUrl = datas.imgUrl;
	        $(document).ready(function () {
	            if (site.isWeiXin()) {
	                wx.ready(function () {
	
	                    // 2. 分享接口
	                    // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
	                    wx.onMenuShareAppMessage({
	                        title: title,
	                        desc: dec,
	                        link: share_url,
	                        imgUrl: imgUrl,
	                        trigger: function trigger(res) {
	                            // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
	
	                        },
	                        success: function success(res) {},
	                        cancel: function cancel(res) {},
	                        fail: function fail(res) {
	                            //alert(JSON.stringify(res));
	                        }
	                    });
	
	                    // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
	                    wx.onMenuShareTimeline({
	                        title: title,
	                        desc: dec,
	                        link: share_url,
	                        imgUrl: imgUrl,
	                        trigger: function trigger(res) {
	                            // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
	
	                        },
	                        success: function success(res) {},
	                        cancel: function cancel(res) {},
	                        fail: function fail(res) {
	                            //alert(JSON.stringify(res));
	                        }
	                    });
	
	                    // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
	                    wx.onMenuShareQQ({
	                        title: title,
	                        desc: dec,
	                        link: share_url,
	                        imgUrl: imgUrl,
	                        trigger: function trigger(res) {
	                            // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
	
	                        },
	                        success: function success(res) {},
	                        cancel: function cancel(res) {},
	                        fail: function fail(res) {
	                            //alert(JSON.stringify(res));
	                        }
	                    });
	
	                    // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
	                    wx.onMenuShareWeibo({
	                        title: title,
	                        desc: dec,
	                        link: share_url,
	                        imgUrl: imgUrl,
	                        trigger: function trigger(res) {
	                            // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
	
	                        },
	                        success: function success(res) {},
	                        cancel: function cancel(res) {},
	                        fail: function fail(res) {
	                            //alert(JSON.stringify(res));
	                        }
	                    });
	                });
	            } else {
	                site.share();
	                var $config = {
	                    url: share_url, // 网址，默认使用 window.location.href
	                    source: title, // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
	                    title: title, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
	                    description: dec, // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
	                    image: imgUrl, // 图片, 默认取网页中第一个img标签
	                    sites: ['qzone', 'qq', 'weibo', 'wechat'], // 启用的站点
	                    disabled: ['google', 'facebook', 'twitter'], // 禁用的站点
	                    wechatQrcodeTitle: "扫一扫：分享", // 微信二维码提示文字
	                    wechatQrcodeHelper: '<p>' + dec + '</p>'
	                };
	                $('#yd-share').share($config);
	            }
	        });
	    },
	    /**
	     * 获取微信token,
	     * 设置微信config
	     * @apiList 需要调用的微信api
	     * @callback 设置完成回调
	     * @param 回调参数
	     * */
	    getWxToken: function getWxToken(apiList, callback, param) {
	        var puurl = encodeURIComponent(location.href.split('#')[0]); //
	        var url = "http://www.yaduo.com:9300/api/meb/ActMebDayByGetWechatConfig?pageUrl=" + puurl;
	        $.ajax({
	            url: url,
	            dataType: "json",
	            cache: true,
	            type: 'GET',
	            success: function success(data) {
	                var cofigData = data.Data;
	                var config = {
	                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
	                    appId: cofigData.AppId, // 必填，企业号的唯一标识，此处填写企业号corpid
	                    timestamp: cofigData.TimeStamp, //必填，生成签名的时间戳
	                    nonceStr: cofigData.NonceStr, // 必填，生成签名的随机串
	                    signature: cofigData.Signature, // 必填，签名，见附录1
	                    jsApiList: apiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
	                    //startRecord开始录音接口，startRecord识别音频并返回识别结果接口，stopRecord停止录音接口，playVoice播放语音接口
	                };$(document).ready(function () {
	                    wx.config(config);
	                    wx.error(function (res) {});
	                    if (callback && Object.prototype.toString.call(callback) === '[object Function]') callback.apply(this, [param]);
	                });
	            },
	            error: function error(data) {}
	        });
	    },
	    /**
	     * 分享
	     * @success data.success, // 分享成功
	     * @callback 记载成功后返回的方法
	     * */
	    share: function share(callback) {
	        if (this.isWeiXin()) {
	            this.getWxToken(['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo'], callback);
	        } else {
	            var jia = '<div class="jiathis_style_32x32">' + '<p class="share-title">分享</p>' + '<p class="share-title" id="yd-share"></p>' + '<p class="share-cancle" >取消</p>' + '</div> ' + '<script type="text/javascript" src="app/js/lib/jquery.share.min.js" charset="utf-8"></script>' + '<link rel="stylesheet" href="app/css/lib/share.min.css">';
	            $('#i_share').html(jia);
	            if (callback && Object.prototype.toString.call(callback) === '[object Function]') callback.apply();
	        }
	    },
	
	    /**
	     * 经纬度算距离
	     * @param {Object} lat1
	     * @param {Object} lng1
	     * @param {Object} lat2
	     * @param {Object} lng2
	     * */
	    getGreatCircleDistance: function getGreatCircleDistance(lat1, lng1, lat2, lng2) {
	        var EARTH_RADIUS = 6378137.0; //单位M
	        var PI = Math.PI;
	
	        function getRad(d) {
	            return d * PI / 180.0;
	        }
	
	        var radLat1 = getRad(lat1);
	        var radLat2 = getRad(lat2);
	
	        var a = radLat1 - radLat2;
	        var b = getRad(lng1) - getRad(lng2);
	
	        var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
	        s = s * EARTH_RADIUS;
	        s = Math.round(s * 10000) / 10000.0;
	        return (s / 1000).toFixed(2) + "公里";
	    },
	
	    /**
	     * 获取当前城市经纬度
	     * */
	    getCity: function getCity() {
	        var mapObj = new AMap.Map('container');
	        mapObj.plugin(["AMap.CitySearch"], function () {
	            //实例化城市查询类
	            var citysearch = new AMap.CitySearch();
	            //自动获取用户IP，返回当前城市
	            citysearch.getLocalCity();
	            AMap.event.addListener(citysearch, "complete", function (result) {
	                var p = result.rectangle.split(';');
	                site.getSession("currentLongitude", p[0].split(',')[0]);
	                site.getSession("currentLatitude", p[0].split(',')[1]);
	            });
	            AMap.event.addListener(citysearch, "error", function (result) {});
	        });
	    },
	    /**
	     * 获取当前经纬度
	     * */
	    getUserLocation: function getUserLocation(callback) {
	        var map, geolocation;
	        $('#auour_loading').show();
	        //if(this.isWeiXin()&&wx){
	        //    this.getWxToken(['getLocation']);
	        //    wx.getLocation({
	        //        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
	        //        success: function (res) {
	        //            var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
	        //            var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
	        //            //var speed = res.speed; // 速度，以米/每秒计
	        //            //var accuracy = res.accuracy; // 位置精度
	        //            $('#auour_loading').hide();
	        //            site.getSession("currentLongitude", longitude);
	        //            site.getSession("currentLatitude", latitude);
	        //            callback.apply(this, [{success: 1}]);
	        //        }
	        //    });
	        //}else{
	        //加载地图，调用浏览器定位服务
	        map = new AMap.Map('container', {
	            resizeEnable: true
	        });
	        map.plugin('AMap.Geolocation', function () {
	            geolocation = new AMap.Geolocation({
	                enableHighAccuracy: true, //是否使用高精度定位，默认:true
	                timeout: 3000, //超过10秒后停止定位，默认：无穷大
	                buttonOffset: new AMap.Pixel(10, 50), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
	                zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
	                buttonPosition: 'RB'
	            });
	            map.addControl(geolocation);
	            geolocation.getCurrentPosition();
	            AMap.event.addListener(geolocation, 'complete', onComplete); //返回定位信息
	            AMap.event.addListener(geolocation, 'error', onError); //返回定位出错信息
	        });
	
	        //解析定位结果
	        function onComplete(data) {
	            $('#auour_loading').hide();
	            site.getSession("currentLongitude", data.position.getLng());
	            site.getSession("currentLatitude", data.position.getLat());
	            callback.apply(this, [{
	                success: 1,
	                city: data.addressComponent.province,
	                latitude: data.position.getLat(),
	                longitude: data.position.getLng()
	            }]);
	        }
	
	        //解析定位错误信息
	        function onError(data) {
	            $('#auour_loading').hide();
	            toast.showToast('定位失败');
	            callback.apply(this, [{ error: 1 }]);
	        }
	
	        //}
	    },
	    /**
	     * 页面跳转定向
	     * */
	    atourlifeGo: function atourlifeGo(h) {
	        var arr = [],
	            _href = h;
	        if (h.indexOf('atourlife://') > -1) {
	            if (h.indexOf('?')) {
	                arr = h.split('?');
	            } else {
	                arr[0] = h;
	            }
	            var path = {
	                hoteldetails: 'http://wechat.yaduo.com/weixin/hotelDetail.html',
	                bambooRoom: 'http://wechat.yaduo.com/plugInUnit/BambooRoom/bambooroom.html'
	            };
	            _href = path[arr[0].split('://')[1]] + (arr[1] ? '?' + arr[1] : '');
	        }
	        //if (this.isMobile()) {
	        //    window.location.href = h;
	        //} else {
	        window.location.href = _href;
	        //}
	    },
	    /**
	     * 判断是否手机打开
	     * */
	    isMobile: function isMobile() {
	        var mobileAgent = new Array("iphone", "ipod", "ipad", "android", "mobile", "blackberry", "webos", "incognito", "webmate", "bada", "nokia", "lg", "ucweb", "skyfire");
	
	        var browser = navigator.userAgent.toLowerCase();
	
	        var isMobile = false;
	
	        for (var i = 0; i < mobileAgent.length; i++) {
	            if (browser.indexOf(mobileAgent[i]) != -1) {
	                isMobile = true;
	
	                break;
	            }
	        }
	        return isMobile;
	    },
	    /**
	     * 获取微信授权
	     * */
	    getOpenId: function getOpenId() {
	        if (!site.getLocal('openId') && site.isWeiXin()) {
	            window.location.href = site.javaHttp + 'weixin/login';
	        }
	    },
	    toastCode: {
	        toasts: false,
	        _toasts: false,
	        pages: false,
	        dialogs: false,
	        _dialogs: false,
	        passwords: false,
	        others: false,
	        content: ''
	    },
	    toast: function toast(obj, code, msg) {
	        obj.toasts[code] = true;
	        obj.toasts['content'] = msg;
	    }
	};
	window.site = site;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(140);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	    city: '', //当前城市
	    latitude: '', // 当前位置纬度
	    longitude: '', // 当前位置经度
	    userInfo: null, //用户信息
	    hotelId: null, //酒店id
	    remarkText: null, //可选备注内容
	    invoice: false, //开发票
	    address: null, //选择地址
	    login: true, //是否登录
	    imgPath: null //头像地址
	};
	
	exports.default = new _vuex2.default.Store({
	    state: state
	});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _touch = __webpack_require__(31);
	
	var _touch2 = _interopRequireDefault(_touch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addHtml = {
	
		//页面加载html
		loadingHtml: '<div id="auour_loading" class="loading">' + '<div class="load-mid">' + '<p>正在加载⋯</p>' + '</div>' + '</div>',
	
		//提示html
		showToast: '<div class="toast-mask"></div>' + '<div id="i_toast_show" class="toast-content"></div>',
	
		//提示html
		showToastWhite: '<div class="toast-mask"></div>' + '<div id="i_toast_white_show" class="toast-content" style="background:#fff;color: #000;padding:20px"></div>',
	
		//确认html
		comfirmToast: '<div id="i_comfirm_toast" class="toast-body">' + '<div class="toast-msg"></div>' + '<div class="toast-confirm toast-btn"></div>' + '</div>',
		//输入密码的遮罩不需要了
		//输入密码
		// passwordToast: '<div class="toast-body hide" id="i_password_toast" ><div class="white-bg toast-main border-radius-10"> <span class="toast_del"><img style="max-width: 20px" src="./app/image/order/X.png" alt=""></span>' +
		// 	'<div class="text-center toast-msg">请输入您的支付密码</div> ' +
		// 	'<div class="password-box"> ' +
		// 	'<p class="text-center box" style="margin:0 10px"><span></span> ' +
		// 	'<span></span> ' +
		// 	'<span></span> ' +
		// 	'<span></span> ' +
		// 	'<span></span> ' +
		// 	'<span></span> </p> ' +
		// 	'<div class="password-input-box"> ' +
		// 	'<input type="password" id="password_toast_input" maxlength="6" readonlyunselectable="on" > ' +
		// 	'</div><p style="line-height: 40px;padding-right: 10px" class="text-right"><a href="./modifyPayment.html" class="min-text blue">忘记密码</a></p>' +
		// 	'</div>' +
		// 	'<div class="toast-btn blue password-box-btn"><span>确定</span></div></div></div>',
	
		//确认取消html
		toComfirmToast: '<div id="i_check_toast" class="toast-body hide">' + '<div class="toast-msg"></div>' + '<div class="box">' + '<div class="toast-btn toast-back cell-bl-1"><span>取消</span></div>' + '<div class="toast-btn cell-bl-1 toast-check"><span>确定</span></div>' + '</div></div>',
	
		//浏览器指向图片
		// toOther: '<img id="i_other" class="other-img" src="./app/image/home/share.png">',
	
		//页面滑出
		page: '<div id="i_page"></div>',
		//保持弹出
		toKeepToast: '<div id="i_keep_toast" class="toast-keep border-radius-5 toast-body"></div>',
		share: '<div id="i_share" class="share-content"></div>'
	};
	var html = '';
	for (var h in addHtml) {
		html += addHtml[h];
	}
	(0, _touch2.default)('body').append(html);
	
	var toast = {
		/**
	  *
	  *  */
		passwordToast: function passwordToast(callback, param) {
			var _this = this;
			var passwordInpt = (0, _touch2.default)("#password_toast_input");
			passwordInpt.val("");
			(0, _touch2.default)('.password-box span').text("");
			this.mask.show();
			this.password.show();
			passwordInpt.off().on('keyup', _toBlur);
			this.delete.off().on('click', function () {
				_this.toHide();
			});
			var params = param ? param : {};
			(0, _touch2.default)(".password-box-btn").off().on('click', function () {
				params.password = passwordInpt.val();
				if (params.password.length == 6) {
					_this.toHide();
					if (callback && Object.prototype.toString.call(callback) === '[object Function]') callback.apply(_this, [params]);
				}
			});
		},
		/**
	  * 视图弹出层
	  * @html 显示html文案
	  * @callback 回调函数
	  * @param 回调函数所需参数
	  * */
		showToast: function showToast(html, callback, param) {
			var _this = this;
			this.mask.show();
			this.showContent.show().html(html);
			setTimeout(function () {
				_this.hide(callback, param);
			}, 1500);
		},
		/**
	  * 白色视图弹出层
	  * @html 显示html文案
	  * @callback 回调函数
	  * @param 回调函数所需参数
	  * */
		showToastWhite: function showToastWhite(html, callback, param) {
			var _this = this;
			this.mask.show();
			this.showContentWhite.show().html(html);
			this.mask.off().on('click', function () {
				_this.hide(callback, param);
			}).on('touchmove', function (e) {
				e.preventDefault(); //阻止默认行为
			});
		},
	
		/**
	  * 确认弹出层
	  * @html 显示html文案
	  * @btn 按钮数组 例:{cancel:'xx',confirm:'xx'}
	  * @callback 回调函数
	  * @param 回调函数所需参数
	  * */
		_showConfirm: function _showConfirm(html, btn, callback, param) {
			var _this = this;
			this.mask.show();
			this.check.show();
			this.msg.html(html);
			this.back.html(btn.cancel).off().on('click', function () {
				_this.hide();
			});
			this.confirm.html(btn.confirm).off().on('click', function () {
				_this.hide(callback, param);
			});
		},
	
		/**
	  * 确认取消弹出层
	  * @html 显示html文案
	  * @btn 按钮数组 例:'知道了'
	  * @callback 回调函数
	  * @param 回调函数所需参数
	  * */
		_showCheck: function _showCheck(html, btn, callback, param) {
			var _this = this;
			this.mask.show();
			this.toComfirm.show();
			this.msg.html(html);
			this.confirm.html(btn).off().on('click', function () {
				_this.hide(callback, param);
			});
		},
	
		/**
	  * 页面滑动层
	  * @html 显示html文案
	  * */
		_showPage: function _showPage(html) {
			this.page.html(html);
			setTimeout(function () {
				(0, _touch2.default)(".page").addClass('all').find('.header-return-img').show().off().on('click', function () {
					(0, _touch2.default)(this).hide();
					(0, _touch2.default)(".page").removeClass('all');
				});
			}, 200);
		},
	
		/**
	  *  查看弹出层
	  *  @html 显示html文案
	  * */
		_showKeepToast: function _showKeepToast(html) {
			var _this = this;
			this.mask.show().on('click', function () {
				_this.toHide();
			});
			this.keep.show().html(html);
		},
	
		/**
	  * 回调影藏
	  * @callback 回调函数
	  * @param 回调函数所需参数
	  * */
		hide: function hide(callback, param) {
			var _this = this;
			if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
				callback.apply(_this, [param]);
			} else {
				this.toHide();
			}
		},
	
		/**
	  * 影藏弹出层
	  * */
		toHide: function toHide() {
			this.mask.hide();
			this.content.hide();
		},
	
		/**
	  * 分享图层显示
	  * */
		shareToast: function shareToast() {
			var _this = this;
			this.mask.show();
			this.share.show();
			this.mask.off().on('click', function () {
				_this.toHide();
			});
			(0, _touch2.default)('.share-cancle').off().on('click', function () {
				_this.toHide();
			});
		},
	
		/**
	  * 跳转其他浏览器显示
	  * */
		showOtherToast: function showOtherToast(b) {
			var _this = this;
			this.mask.show();
			this.other.show();
			if (!b) {
				this.mask.off().on('click', function () {
					_this.hide();
				});
			}
		}
	};
	_touch2.default.extend(toast, {
		mask: (0, _touch2.default)(".toast-mask"),
		content: (0, _touch2.default)(".toast-content,.toast-body,.toast-keep,.share-content,.other-img"),
		showContent: (0, _touch2.default)("#i_toast_show"),
		showContentWhite: (0, _touch2.default)("#i_toast_white_show"),
		confirm: (0, _touch2.default)(".toast-confirm, .toast-check"),
		check: (0, _touch2.default)("#i_check_toast"),
		toComfirm: (0, _touch2.default)("#i_comfirm_toast"),
		msg: (0, _touch2.default)(".toast-msg"),
		back: (0, _touch2.default)(".toast-back"),
		keep: (0, _touch2.default)("#i_keep_toast"),
		page: (0, _touch2.default)("#i_page"),
		password: (0, _touch2.default)("#i_password_toast"),
		delete: (0, _touch2.default)(".toast_del"),
		share: (0, _touch2.default)("#i_share"),
		other: (0, _touch2.default)("#i_other")
	});
	window.toast = toast;
	
	function _toBlur() {
		var val = (0, _touch2.default)(event.currentTarget).val();
		var len = val.length;
		for (var i = 0; i < 6; i++) {
			if (i < len) {
				(0, _touch2.default)(".password-box .box span").eq(i).text('●');
			} else {
				(0, _touch2.default)(".password-box .box span").eq(i).text("");
			}
		}
	}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(139);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(114);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _treatment = __webpack_require__(124);
	
	var _treatment2 = _interopRequireDefault(_treatment);
	
	var _treatmentList = __webpack_require__(125);
	
	var _treatmentList2 = _interopRequireDefault(_treatmentList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	var routers = {
	    routes: [{
	        path: '/',
	        component: _App2.default,
	        children: [{
	            path: '',
	            redirect: '/home/133',
	            name: 'home'
	        }, {
	            path: '/home/:marketId',
	            component: _treatment2.default,
	            name: 'home'
	        }, {
	            path: '/treatmentList/:marketId',
	            component: _treatmentList2.default,
	            name: 'treatmentList'
	        }]
	    }],
	    mode: 'hash',
	    strict: false
	};
	
	var router = new _vueRouter2.default(routers);
	var title = {
	    home: { title: '首页', limit: 'noPath' },
	    treatmentList: { title: '兑换信息', limit: 'noPath' }
	};
	
	router.beforeEach(function (to, from, next) {
	    if (to.query.activitySource) {
	        if (!localStorage.getItem('firstEnterTime')) {
	            localStorage.setItem('firstEnterTime', new Date().getTime());
	            if (!localStorage.getItem('activitySource') && !localStorage.getItem('activeId')) {
	                localStorage.setItem('activitySource', to.query.activitySource);
	                localStorage.setItem('activeId', to.query.activeId);
	            }
	        } else {
	            var firstTime = parseInt(localStorage.getItem('firstEnterTime'));
	            var now = new Date().getTime();
	            var timeDiff = Math.floor((now - firstTime) / (1000 * 60 * 60));
	            if (timeDiff > 30) {
	                localStorage.setItem('activitySource', '');
	                localStorage.setItem('activeId', '');
	            }
	        }
	    }
	    var path = to.path;
	    var pastPage = site.getLocal('current');
	    //添加页面标题
	    document.title = title[to.name].title;
	    //设置上一页缓存
	    localStorage.setItem('referrers', window.location.href);
	    //判断页面是否需要登陆
	    if (title[to.name] && title[to.name].limit == 'login' && !site.isLogin()) {
	        if (Prius && Prius.isInsideApp) {
	            Prius.login();
	        } else {
	            router.go('#/' + title[to.name].limit);
	        }
	    }
	    ////判断页面是否纪录历史
	    if (title[to.name] && title[to.name].limit == 'noPath') {
	        next();
	        return;
	    }
	    if (pastPage != undefined && path != pastPage) {
	        site.getLocal('referrer', pastPage);
	    }
	    site.getLocal('current', path);
	    next();
	});
	
	exports.default = router;

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dist/img/shares.8a8ab62.png";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(134),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(105)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(45),
	  /* template */
	  __webpack_require__(136),
	  /* scopeId */
	  "data-v-cff2ae9a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(102)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(46),
	  /* template */
	  __webpack_require__(132),
	  /* scopeId */
	  "data-v-7a4752e6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(104)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(47),
	  /* template */
	  __webpack_require__(135),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(103)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(48),
	  /* template */
	  __webpack_require__(133),
	  /* scopeId */
	  "data-v-7e485641",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(106)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(49),
	  /* template */
	  __webpack_require__(137),
	  /* scopeId */
	  "data-v-dae39bfc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(99)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(50),
	  /* template */
	  __webpack_require__(129),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(98)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(51),
	  /* template */
	  __webpack_require__(128),
	  /* scopeId */
	  "data-v-23a7a8e9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(100)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(52),
	  /* template */
	  __webpack_require__(130),
	  /* scopeId */
	  "data-v-4bd82890",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(101)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(53),
	  /* template */
	  __webpack_require__(131),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(96)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(54),
	  /* template */
	  __webpack_require__(126),
	  /* scopeId */
	  "data-v-02750f7b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(97)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(55),
	  /* template */
	  __webpack_require__(127),
	  /* scopeId */
	  "data-v-144d7bb9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', [(_vm.configType) ? [_c('div', {
	    staticClass: "wrap"
	  }, [_c('section', {
	    staticClass: "activity-bg"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.configData.backgroundImage
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content-topbox"
	  }, [_c('div', {
	    staticClass: "content-shareimg"
	  }, [_c('share', {
	    attrs: {
	      "title": _vm.configData.title,
	      "desc": _vm.configData.shareUrlTitle,
	      "imgUrl": _vm.configData.shareUrlImage
	    }
	  })], 1), _vm._v(" "), _c('img', {
	    staticClass: "content-logimg",
	    attrs: {
	      "src": _vm.configData.logoImage
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "content-bottbox"
	  }, [_c('div', {
	    staticClass: "img-wrap"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.configData.envelopeImage
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "content-val"
	  }, [_c('div', {
	    staticClass: "input-wrap"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.postData.phoneNum),
	      expression: "postData.phoneNum"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "请正确填写手机号"
	    },
	    domProps: {
	      "value": (_vm.postData.phoneNum)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.postData, "phoneNum", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "input-wrap"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.postData.verifyCode),
	      expression: "postData.verifyCode"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "请输入验证码"
	    },
	    domProps: {
	      "value": (_vm.postData.verifyCode)
	    },
	    on: {
	      "focus": _vm.closeImg,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.postData, "verifyCode", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "login-get-code msg",
	    on: {
	      "click": function($event) {
	        _vm.getImgCode()
	      }
	    }
	  }, [_vm._v("获取验证码")])]), _vm._v(" "), _c('p', {
	    staticClass: "content-button",
	    on: {
	      "click": function($event) {
	        _vm.receiveGifts()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.configData.buttonImage
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "content-introduce",
	    on: {
	      "click": function($event) {
	        _vm.showToast(true)
	      }
	    }
	  }, [_vm._v("活动规则")])])])])]), _vm._v(" "), (_vm.iShow) ? _c('div', [_c('div', {
	    staticClass: "toast-mask",
	    staticStyle: {
	      "display": "block"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showToast(false)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "toast-body"
	  }, [_vm._m(0), _vm._v(" "), _c('pre', {
	    staticClass: "toast-msg"
	  }, [_vm._v(_vm._s(_vm.configData.marketRule))])])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('img-code', {
	    attrs: {
	      "show": _vm.isShow,
	      "phone": _vm.postData.phoneNum,
	      "codeType": _vm.codeType
	    },
	    on: {
	      "showOff": _vm.showOff
	    }
	  })], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "clearfix"
	  }, [_c('p', {
	    staticClass: "toast-title"
	  }, [_vm._v("活动介绍")])])
	}]}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', [(_vm.configType) ? _c('div', {
	    staticClass: "wrap"
	  }, [_c('section', {
	    staticClass: "activity-bg"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.configData.backgroundImage
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content-topbox"
	  }, [_c('share', {
	    attrs: {
	      "title": _vm.configData.subTitle,
	      "desc": _vm.configData.shareUrlTitle,
	      "imgUrl": _vm.configData.shareUrlImage,
	      "link": _vm.link
	    }
	  }), _vm._v(" "), (_vm.configData.sort != 3) ? _c('img', {
	    staticClass: "content-logimg",
	    attrs: {
	      "src": _vm.configData.logoImage
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.configData.sort == 3) ? _c('img', {
	    staticClass: "content-logimg",
	    attrs: {
	      "src": _vm.configData.successSubTitle
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.configData.sort != 3) ? _c('div', {
	    staticClass: "envelope-prompt"
	  }, [_c('p', [_vm._v(_vm._s(_vm.isLogin ? "已成功领取" : "领取成功"))]), _vm._v(" "), _c('span', [_vm._v("优惠券已放入" + _vm._s(_vm.upPhoneNum(_vm.phone)) + "的会员账户")])]) : _vm._e(), _vm._v(" "), (_vm.configData.sort == 3) ? _c('div', {
	    staticClass: "envelope-prompt"
	  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("专属百元礼包已放入您的亚朵账户")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "content-bottbox",
	    style: (_vm.configData.marketValue == 1 ? '' : (_vm.configData.envelopeImage ? ('background: url(' + _vm.configData.envelopeImage + ') no-repeat;background-size: 100% 100%;') : ''))
	  }, [_c('ul', {
	    staticClass: "list-css",
	    class: _vm.configData.marketValue == 1 ? 'newbac-css' : 'bac-css',
	    style: (_vm.configData.sort == 3 ? 'bottom: 16%;' : ''),
	    attrs: {
	      "tabindex": "-1"
	    }
	  }, _vm._l((_vm.couponList), function(item) {
	    return _c('li', {
	      staticClass: "clearfix content-img",
	      style: (_vm.configData.successSubTitle ? ('background: url(' + _vm.configData.successSubTitle + ') no-repeat;background-size: 100% 100%;') : '')
	    }, [_c('div', {
	      staticClass: "fl price clearfix",
	      style: (_vm.configData.successTitle ? ('background: url(' + _vm.configData.successTitle + ') no-repeat;background-size: 100% 100%;') : '')
	    }, [_c('p', {}, [_vm._v(_vm._s(item.value) + "元")])]), _vm._v(" "), _c('div', {
	      staticClass: "fr content-fr"
	    }, [_c('p', {
	      staticClass: "count"
	    }, [_vm._v(_vm._s(item.disTypeName))]), _vm._v(" "), _c('p', {
	      staticClass: "count",
	      staticStyle: {
	        "color": "#FB3653"
	      }
	    }, [_vm._v("x" + _vm._s(item.count ? item.count : 1))])])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "bacbottom-img"
	  }, [(_vm.configData.marketValue != 1) ? _c('p', {
	    staticClass: "content-button",
	    style: (_vm.configData.buttonImage ? ('background: url(' + _vm.configData.buttonImage + ') no-repeat;background-size: 100% 100%;') : ''),
	    on: {
	      "click": function($event) {
	        _vm.goWechat()
	      }
	    }
	  }, [_vm._v("\n                        立即使用")]) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "dow-title",
	    on: {
	      "click": _vm.useAction
	    }
	  })])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "size-color"
	  }, [_vm._v("恭喜您\n                        "), _c('br'), _vm._v("成为亚朵金卡会员")])
	}]}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.status),
	      expression: "status"
	    }],
	    staticClass: "toast-bg",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.toCancel($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "toast-body",
	    style: ({
	      'margin-top': _vm.top
	    })
	  }, [_c('div', {
	    staticClass: "white-bg border-radius-10"
	  }, [_c('i', {
	    staticClass: "toast-del",
	    on: {
	      "click": _vm.toCancel
	    }
	  }), _vm._v(" "), _c('h4', {
	    staticClass: "text-center toast-msg"
	  }, [_vm._v("请输入您的支付密码")]), _vm._v(" "), _c('div', {
	    staticClass: "password-box"
	  }, [_c('p', {
	    staticClass: "text-center box",
	    staticStyle: {
	      "margin": "0 10px"
	    }
	  }, _vm._l((_vm.num), function(index, item) {
	    return _c('span', [(_vm.password.length > (index - 1)) ? _c('i', [_vm._v("*")]) : _vm._e()])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "password-input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    attrs: {
	      "type": "password",
	      "maxlength": "6",
	      "readonlyunselectable": "on"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-right",
	    staticStyle: {
	      "line-height": "40px",
	      "padding-right": "10px"
	    }
	  }, [_c('a', {
	    directives: [{
	      name: "link",
	      rawName: "v-link"
	    }],
	    staticClass: "min-text blue"
	  }, [_vm._v("忘记密码")])])]), _vm._v(" "), _c('div', {
	    staticClass: "toast-btn blue password-box-btn",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_c('span', [_vm._v("确定")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "page-bg",
	    class: _vm.classes + (_vm.status ? ' all' : ''),
	    domProps: {
	      "innerHTML": _vm._s(_vm.html)
	    },
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.toCancel($event)
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', [(_vm.type != 1) ? _c('div', {
	    staticClass: "content-shareimg",
	    on: {
	      "click": _vm.toShare
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": _vm.shareimage,
	      "alt": ""
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.status || _vm.statuses) ? _c('section', {
	    staticClass: "toast-bg",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.toCancel($event)
	      }
	    }
	  }, [(_vm.statuses) ? _c('img', {
	    staticClass: "img-share",
	    attrs: {
	      "src": __webpack_require__(113),
	      "alt": ""
	    }
	  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.status) ? _c('div', {
	    staticClass: "toast-box border-radius-10"
	  }, [_c('p', {
	    staticClass: "share-title text-center"
	  }, [_vm._v("分享")]), _vm._v(" "), _c('p', {
	    staticClass: "share-title text-center"
	  }, [_c('a', {
	    staticClass: "icons qzone",
	    attrs: {
	      "href": 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + _vm.upVal(_vm.link) + '&title=' + _vm.upVal(_vm.title) + '&pics=' + _vm.upVal(_vm.desc) + '&summary=' + _vm.upVal(_vm.title) + '&site=' + _vm.upVal(_vm.title) + '&pics=' + _vm.img + '&site=' + _vm.upVal(_vm.title) + ''
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "icons qq",
	    attrs: {
	      "href": 'http://connect.qq.com/widget/shareqq/index.html?url=' + _vm.upVal(_vm.link) + '&title=' + _vm.upVal(_vm.title) + '&source=亚朵&desc=' + _vm.upVal(_vm.desc) + '&pics=' + _vm.upVal(_vm.img)
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "icons weibo",
	    attrs: {
	      "href": 'http://service.weibo.com/share/share.php?url=' + _vm.upVal(_vm.link) + '&title=' + _vm.upVal(_vm.title) + '&pic=' + _vm.upVal(_vm.img) + '&appkey='
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "share-cancle text-center",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.toCancel($event)
	      }
	    }
	  }, [_vm._v("取消")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "time-box-1"
	  }, [_c('span', [_vm._v(_vm._s(_vm.hour > 9 ? parseInt(_vm.hour / 10) : 0))]), _c('span', [_vm._v(_vm._s(_vm.hour % 10))]), _vm._v(" "), _c('span', {
	    staticClass: "none-sty"
	  }, [_vm._v(":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.minute > 9 ? parseInt(_vm.minute / 10) : 0))]), _c('span', [_vm._v(_vm._s(_vm.minute % 10))]), _vm._v(" "), _c('span', {
	    staticClass: "none-sty"
	  }, [_vm._v(":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.second > 9 ? parseInt(_vm.second / 10) : 0))]), _c('span', [_vm._v(_vm._s(_vm.second % 10))])])
	},staticRenderFns: []}

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "date-box"
	  }, _vm._l((_vm.data), function(item, index) {
	    return (item.length > 0) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.monthName[index]))]), _vm._v(" "), _vm._l((item[0].week), function(it) {
	      return _c('span')
	    }), _vm._v(" "), _vm._l((item), function(items, ind) {
	      return _c('span', {
	        class: {
	          'gray': items.status, 'on': items.selected, 'green': (!items.status) && items.time >= _vm.start && items.time <= _vm.end
	        },
	        on: {
	          "click": function($event) {
	            _vm.setTime(items, ind)
	          }
	        }
	      }, [_vm._v("\n            " + _vm._s(items.day) + "\n        ")])
	    })], 2) : _vm._e()
	  }))
	},staticRenderFns: []}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "img-pop"
	  }, [_c('p', [_vm._v("请输入验证码")]), _vm._v(" "), _c('div', {
	    staticClass: "code-wrap"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.code),
	      expression: "code"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.code = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "img-code-btn",
	    on: {
	      "click": _vm.getImg
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.imgCode
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-wrap"
	  }, [_c('span', {
	    staticClass: "pop-btn",
	    on: {
	      "click": _vm.getCode
	    }
	  }, [_vm._v("确定")])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "img-mask"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('router-view', {
	    attrs: {
	      "keep-alive": "",
	      "transition-mode": "out-in"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "clearfix"
	  }, [_c('div', {
	    staticClass: "hd-right"
	  }, [_vm._t("right")], 2), _vm._v(" "), _c('div', {
	    staticClass: "hd-left"
	  }, [_vm._t("left")], 2), _vm._v(" "), _c('h5', {
	    staticClass: "title",
	    on: {
	      "click": _vm.toGo
	    }
	  }, [_vm._t("title")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn",
	    on: {
	      "click": _vm.sendMessage
	    }
	  }, [_vm._v(_vm._s(_vm.val))])
	},staticRenderFns: []}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.status),
	      expression: "status"
	    }],
	    staticClass: "toast-bg",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.toCancel($event)
	      }
	    }
	  }, [_c('img', {
	    class: _vm.classes,
	    attrs: {
	      "src": _vm.imgs,
	      "alt": ""
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// dist/js/app.4d1c9bf3889298185447.js